/* ==========================================================================
 * ans-facets.js — filtrado facetado sin recarga
 * Proyecto: Theme/projects/2026-07-19_reemplazo-globo · DISENO-TECNICO.md §2
 *
 * Sin dependencias, sin build. No usa jQuery aunque el tema la cargue: una
 * dependencia menos es un modo de fallo menos.
 *
 * PRINCIPIO RECTOR: la URL es el estado. El DOM es una proyección de la URL.
 * Nunca al revés. Por eso toda interacción produce primero una URL y luego un
 * render de esa URL — jamás un render "adivinado" que después se escribe en la
 * barra de direcciones.
 * ========================================================================== */

(function () {
  'use strict';

  /* ⚙️ INTERRUPTOR MAESTRO del grid de /search worker-driven (render per-handle).
   * FALSE (modo A, mitigación temporal jul 28): /search usa el grid NATIVO server-side (INSTANTÁNEO) + badges.js
   * (oculta basura + conteo preciso, sin fetches) + fallback de typos. El render per-handle sumaba 8+ s en 4G real
   * (medido: 12.6s vs 4.1s nativo) → demasiado lento para móvil. TRUE reactiva el grid worker (para cuando B —el
   * worker cachee el HTML de las cards y /busqueda las devuelva en 1 request— lo haga rápido de verdad).
   * El código worker-driven queda INTACTO detrás de este flag; A no borra, desactiva. */
  var ANS_SEARCH_WORKER_GRID = true;

  /* HANDOFF con badges.js: si el grid worker está activo, ESTE módulo es dueño único en /search y badges.js no toca
   * grid/conteo. En modo A (flag false) NO se iza → badges.js retoma su oculta-basura + conteo (instantáneo). */
  if (ANS_SEARCH_WORKER_GRID && /\/search\b/.test(location.pathname)) { window.ANS_BUSQUEDA_PROPIA = true; }

  // --- Constantes -----------------------------------------------------------

  var DEBOUNCE_PRECIO_MS = 400;

  /* Sección de UNA card (Section Rendering per-handle): /products/<h>?sections=ans-search-card → el HTML de la
   * card REAL del tema (add-to-cart, reseñas, badge de descuento, "X+ comprados" nativos → cero drift). La usan
   * el render worker-driven de /search y su fallback. */
  var ANS_SEC_CARD = 'ans-search-card';

  /* La paginación se engancha por atributo PROPIO; la clase de Wokiee es solo
   * respaldo para el caso de que este atributo aún no esté desplegado. */
  var SEL_PAGINACION = '[data-ans-pagination]';
  var SEL_PAGINACION_RESPALDO = '.tt_product_showmore';

  /* --- El id de la sección: SE LEE DEL DOM, NUNCA SE ESCRIBE A MANO ---------
   *
   * BUG DE CLASE CAZADO EN EL NAVEGADOR (jul 20 2026). Aquí estaba escrito
   * `var SECCION = 'main'`, leído de `templates/collection.json`, donde la
   * clave de la sección efectivamente es "main". Pero esa clave NO es el id:
   * en una plantilla JSON Shopify genera el id real
   * `template--22157793362174__main`. Con 'main' la petición a la Section
   * Rendering API no devolvía esa clave, `render()` lanzaba y caía siempre a
   * navegación completa: la actualización sin recargar NUNCA funcionó.
   *
   * Sustituir un literal por el otro sería un PARCHE: ese id lleva dentro un
   * identificador de la plantilla/tema, así que duplicar el tema, crear otra
   * plantilla o instalar esto en otra tienda lo cambia y el bug vuelve.
   *
   * La fuente autoritativa en tiempo de ejecución es el envoltorio que Shopify
   * emite alrededor de TODA sección: `<div id="shopify-section-{id}">`. Es
   * exactamente lo que recomienda la doc oficial de Section Rendering API
   * ("extraer el id del atributo id del envoltorio de la sección"), y es el
   * mismo mecanismo que usan los temas oficiales.
   *
   * Si no hay envoltorio (el snippet se usó fuera de una sección), NO se
   * adivina: `resolverSeccion()` devuelve null y `render()` degrada a
   * navegación real. Fallar visible y funcional, nunca adivinar.
   */
  var PREFIJO_SECCION = 'shopify-section-';
  var seccionCache = null;

  function resolverSeccion() {
    if (seccionCache) return seccionCache;
    var ancla = document.getElementById('ans-facets') ||
                document.getElementById('ans-grid');
    if (!ancla) return null;
    var envoltorio = ancla.closest('[id^="' + PREFIJO_SECCION + '"]');
    if (!envoltorio) return null;
    seccionCache = envoltorio.id.slice(PREFIJO_SECCION.length);
    return seccionCache || null;
  }

  /* Punto de enganche para los 2 ordenamientos propios (Disponibilidad y Mayor
   * descuento, DISENO-TECNICO §5). HOY VACÍO A PROPÓSITO: su motor (índice
   * precalculado + sección ans-grid-handles) todavía no existe. Ofrecer la
   * opción sin el motor daría un `sort_by` que Shopify ignora y que cae al
   * orden por defecto SIN avisar — el defecto exacto de Globo que no se
   * replica. Cuando §5 exista se rellena esta lista: aparecen solo con JS,
   * que es la degradación declarada en §3.4. */
  var ANS_ORDENES_PROPIOS = [
    // Mayor descuento (sale-descending): Shopify no ordena por descuento; el motor es el worker /orden (por % de
    // dcto = (compareAt-precio)/compareAt, decisión jul 27). Aparece SOLO con JS (inyectarOrdenesPropios), que es la
    // degradación declarada en §3.4 — sin JS no se ofrece una opción que Shopify ignoraría.
    { valor: 'sale-descending', etiqueta: 'Mayor descuento' },
  ];

  // --- Estado del módulo ----------------------------------------------------

  /* Memoria del último estado ya pintado. Es la GUARDA DURA anti-bucle: si la
   * URL actual ya está reflejada en el DOM, no se vuelve a renderizar. */
  /* OJO con la premisa de esta guarda: dice "el DOM ya refleja esta URL". Eso solo es
   * cierto si el SERVIDOR pudo honrarla. Con un orden PROPIO no puede: Shopify ignora
   * `sale-descending` y pinta su orden por defecto, así que sembrar la guarda con esa
   * URL hacía que el motor no se llamara nunca y el grid se quedara mal ordenado —
   * exactamente el "como si en el URL no viajara" que reportó Enrique (12 ago 2026).
   * Se siembra solo cuando el servidor SÍ pudo honrarla; si no, nada está pintado. */
  var ultimoRender = servidorPudoHonrar(window.location.search) ? window.location.search : null;

  /* ¿El render del servidor pudo reflejar esta URL? Hoy la única parte que no puede son
   * nuestros órdenes propios. Cuando aparezca otro parámetro que Shopify no entienda, se
   * agrega AQUÍ y la guarda queda corregida en todos sus usos de una vez. */
  function servidorPudoHonrar(search) {
    try { return !esOrdenPropio(new URLSearchParams(search).get('sort_by')); } catch (e) { return true; }
  }

  /* Bandera de reentrada: mientras se navega por el historial NO se llama a
   * pushState. Llamar a pushState dentro del manejador de popstate es el bucle
   * clásico de este patrón (empuja un estado que dispara otro popstate…). */
  var navegandoPorHistorial = false;

  /* Una sola petición viva. Si la clienta hace clic rápido en 3 colores, la
   * respuesta lenta de la 1ª llegaría DESPUÉS de la 3ª y pintaría un panel que
   * no corresponde a la URL. Abortar la anterior hace imposible esa carrera —
   * no la hace "poco probable": la elimina. */
  var peticionEnCurso = null;

  var temporizadorPrecio = null;

  // --- Utilidades -----------------------------------------------------------

  function $(sel, raiz) { return (raiz || document).querySelector(sel); }
  function $$(sel, raiz) {
    return Array.prototype.slice.call((raiz || document).querySelectorAll(sel));
  }

  /* El form puede ser el de filtros o, si no hay filtros configurados
   * (Search & Discovery sin instalar), el form autónomo de sólo-orden que
   * emite ans-sort.liquid. El módulo funciona con cualquiera de los dos. */
  function obtenerForm() {
    return document.getElementById('ans-facets-form') ||
           document.querySelector('form.ans-sort--standalone');
  }

  // --- Construcción de parámetros (§2.2) ------------------------------------

  function parametrosDesdeForm(form) {
    var params = new URLSearchParams();
    var datos = new FormData(form);

    datos.forEach(function (valor, clave) {
      /* Los inputs de precio vacíos NO se envían: `filter.v.price.gte=` (vacío)
       * es un filtro válido para Shopify y devolvería 0 productos. Borrarlo es
       * lo que distingue "sin límite" de "límite cero". */
      if (valor === '' || valor === null) return;
      params.append(clave, valor);
    });

    /* RESETEO DE PAGINACIÓN. Va SIEMPRE en toda interacción de filtro u orden:
     * estar en la página 3 de 495 productos y filtrar a 10 dejaría una página 3
     * que no existe → rejilla vacía. La única interacción que conserva `page`
     * es la propia paginación, y esa NO pasa por aquí: usa la URL del enlace
     * de Shopify tal cual (ver el manejador de `.tt_product_showmore a`). */
    params.delete('page');

    conservarAjenos(params);
    return params;
  }

  /* Parámetros que el PANEL posee: los emite el form, así que si no están es
   * porque la clienta los quitó. Todo lo demás que traiga la URL es AJENO y se
   * conserva. `sections` es de la Section Rendering API y jamás debe quedarse
   * pegado en la URL de la clienta. */
  var PROPIOS = ['sort_by', 'page', 'sections'];

  function esPropio(clave) {
    return clave.indexOf('filter.') === 0 || PROPIOS.indexOf(clave) !== -1;
  }

  /* GEMELO EN JS DE `ans-params-ajenos.liquid`.
   *
   * Los hidden que emite ese snippet ya cubren el camino sin JS y, de rebote,
   * el FormData. Esto cubre lo que a Liquid NO le alcanza: un valor
   * percent-encoded, que el snippet OMITE a propósito porque Liquid no tiene
   * `url_decode` (devolverlo a un <input> lo re-codificaría: `a%20b` →
   * `a%2520b`). `URLSearchParams` sí decodifica bien, así que aquí se recupera.
   *
   * Solo añade lo que FALTA: si el hidden ya lo trajo, no se duplica. */
  function conservarAjenos(params) {
    var actuales = new URLSearchParams(window.location.search);
    actuales.forEach(function (valor, clave) {
      if (esPropio(clave)) return;
      if (params.has(clave)) return;
      params.append(clave, valor);
    });
  }

  // --- Render (§2.4) --------------------------------------------------------

  /* Se sustituyen EXACTAMENTE 4 nodos, nunca la sección completa.
   *
   * Reemplazar el <div id="shopify-section-main"> entero volvería a ejecutar
   * los <script> inline del banner de reseñas (collection-template.liquid:111
   * y :540), duplicando listeners y modales. Es la versión sutil del error ya
   * cometido de "reconstruí la página y borré el banner rosa": la página se ve
   * bien y por dentro tiene todo duplicado. Por eso el reemplazo es nodo a
   * nodo, y la costura (tarjeta, banner, barra de confianza, encabezado, pie)
   * ni se toca. */
  function intercambiarNodos(docNuevo) {
    // 1) El panel entero: contadores contextuales y opciones que desaparecen.
    var panelViejo = $('#ans-facets');
    var panelNuevo = $('#ans-facets', docNuevo);
    if (panelViejo && panelNuevo) {
      panelViejo.parentNode.replaceChild(panelNuevo, panelViejo);
    }

    // 2) La rejilla: innerHTML, NO el nodo. Conservar el nodo preserva sus
    //    atributos data-settings / data-section-id, que el tema lee después.
    var gridViejo = $('#ans-grid');
    var gridNuevo = $('#ans-grid', docNuevo);
    if (gridViejo && gridNuevo) {
      gridViejo.innerHTML = gridNuevo.innerHTML;
      var cuenta = gridNuevo.getAttribute('data-ans-count');
      if (cuenta !== null) gridViejo.setAttribute('data-ans-count', cuenta);
    }

    /* 3) Paginación / "cargar más".
     *
     * Se busca por `[data-ans-pagination]`, atributo que emite nuestro propio
     * Liquid. `.tt_product_showmore` queda solo como RESPALDO: es un nombre de
     * clase privado de Wokiee y una actualización del tema lo puede renombrar.
     * Antes, si ese nodo no aparecía, el `if` fallaba en silencio y la clienta
     * se quedaba con una paginación congelada apuntando a la URL vieja. Ahora
     * la ausencia se AVISA: lo que falla, falla visible. */
    var pagViejo = $(SEL_PAGINACION) || $(SEL_PAGINACION_RESPALDO);
    var pagNuevo = $(SEL_PAGINACION, docNuevo) || $(SEL_PAGINACION_RESPALDO, docNuevo);
    if (pagViejo && pagNuevo) {
      pagViejo.parentNode.replaceChild(pagNuevo, pagViejo);
    } else if (pagViejo || pagNuevo) {
      console.warn('[ans-facets] paginación desincronizada: nodo actual=' +
        !!pagViejo + ' nodo nuevo=' + !!pagNuevo +
        ' — revisar el atributo data-ans-pagination en collection-template.liquid');
    }

    // 4) Los conteos visibles: el "N Productos" y el "VER N PRODUCTOS" del pie
    //    móvil, que debe ir EN VIVO (495 → 67).
    var cuentaNueva = gridNuevo ? gridNuevo.getAttribute('data-ans-count') : null;
    if (cuentaNueva !== null) {
      $$('.ans-count-value').forEach(function (n) { n.textContent = cuentaNueva; });
    }
    return cuentaNueva;
  }

  // --- Preservación de estado a través del swap (§2.6) ----------------------

  /* CLAVES ESTABLES, NO ÍNDICES. Dawn identifica los grupos por posición; aquí
   * no sirve porque los valores sin resultados DESAPARECEN del DOM (Acabado
   * pasa de 10 opciones a 5), así que el índice 2 puede apuntar a otro grupo
   * después del re-render y se reabriría/enfocaría el equivocado. */
  function capturarEstado() {
    var estado = {
      grupos: {},
      claveFoco: null,
      scrollCajon: 0,
      cajonAbierto: false
    };

    $$('#ans-facets [data-ans-group]').forEach(function (g) {
      estado.grupos[g.getAttribute('data-ans-group')] = g.classList.contains('open');
    });

    var activo = document.activeElement;
    if (activo && activo.dataset && activo.dataset.ansKey) {
      estado.claveFoco = activo.dataset.ansKey;
    }

    var panel = $('.ans-drawer__panel');
    if (panel) estado.scrollCajon = panel.scrollTop;

    var cajon = $('#ans-drawer');
    if (cajon) estado.cajonAbierto = cajon.open;

    return estado;
  }

  function restaurarEstado(estado) {
    Object.keys(estado.grupos).forEach(function (clave) {
      var g = document.querySelector('#ans-facets [data-ans-group="' + cssEscape(clave) + '"]');
      if (!g) return; // el grupo desapareció: nada que restaurar
      g.classList.toggle('open', estado.grupos[clave]);
      var boton = g.querySelector('.ans-group__toggle');
      if (boton) boton.setAttribute('aria-expanded', estado.grupos[clave] ? 'true' : 'false');
    });

    var cajon = $('#ans-drawer');
    if (cajon) cajon.open = estado.cajonAbierto;

    if (estado.claveFoco) {
      var destino = document.querySelector('[data-ans-key="' + cssEscape(estado.claveFoco) + '"]');
      if (destino) {
        destino.focus({ preventScroll: true });
      } else {
        /* El input desapareció: la clienta marcó el último valor de un grupo
         * que se colapsó. El foco NO puede caer al <body>: eso desorienta a un
         * lector de pantalla y hace saltar el scroll a lo alto de la página.
         * Se mueve al título del grupo, que es lo más cercano semánticamente. */
        var idGrupo = estado.claveFoco.split('|')[0];
        var grupo = document.querySelector('#ans-facets [data-ans-group="' + cssEscape(idGrupo) + '"]');
        var titulo = grupo && grupo.querySelector('.ans-group__toggle');
        if (titulo) titulo.focus({ preventScroll: true });
      }
    }

    var panel = $('.ans-drawer__panel');
    if (panel) panel.scrollTop = estado.scrollCajon;
  }

  /* Las claves llevan puntos (`filter.p.m.ans_filtros.color`) y espacios
   * (`acabado_ojo de gato`). Van SIEMPRE dentro de un selector de atributo
   * entrecomillado, así que lo único que hay que escapar es la comilla y la
   * barra invertida. No se usa CSS.escape: escapa para IDENTIFICADORES (le
   * mete barras a cada punto), que aquí no hace falta y solo añade una rama
   * que se comporta distinto según el navegador. */
  function cssEscape(valor) {
    return String(valor).replace(/["\\]/g, '\\$&');
  }

  function escaparHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // --- Chips de filtros activos en la barra (móvil) -------------------------
  /* Enrique jul 29 2026: con el cajón cerrado no se ve qué filtros están puestos → se pinta una fila de chips en la
   * barra (`[data-ans-chips-barra]`, entre controles y conteo, SOLO móvil por CSS). Se construyen desde el ESTADO
   * REAL del form (checkboxes marcados + precio), NO clonando las píldoras del cajón: en /search el render worker no
   * re-renderiza esas píldoras (quedarían stale), pero los checkboxes SÍ reflejan lo aplicado → fuente correcta en
   * colección Y búsqueda. Cada chip quita su filtro (desmarca el checkbox / limpia el precio) → ver el click handler.
   * Se llama tras CADA render y al iniciar. */
  function etiquetaDeCheckbox(cb) {
    var lbl = cb.closest('label');
    var t = lbl && lbl.querySelector('.ans-box__text, .ans-check__text');
    if (t && t.textContent) return t.textContent.trim();
    var vh = lbl && lbl.querySelector('span.ans-visually-hidden');   // swatches: el texto real vive en el SPAN ("Rojo (44)") — el INPUT también lleva .ans-visually-hidden, por eso span.
    if (vh && vh.textContent) return vh.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
    return cb.value || '';
  }
  /* El mensaje "no hay resultados" que emitió la NATIVA es una opinión sobre SU búsqueda, no sobre lo que la
   * clienta acaba termina viendo (el grid lo manda el worker). Se sincroniza con el total REAL de cada render:
   * total>0 → fuera (o contradiría al grid); total==0 → se muestra. Sin nodo, no hace nada. */
  function sincronizarVacio(total) {
    var vac = $('[data-ans-vacio]');
    if (!vac) return;
    if (total > 0) { if (vac.parentNode) vac.parentNode.removeChild(vac); }
    else { vac.hidden = false; vac.style.display = ''; }
  }

  function sincronizarChips() {
    var barra = $('[data-ans-chips-barra]');
    if (!barra) return;
    var items = [];
    $$('#ans-facets .ans-list__item input[type="checkbox"]:checked').forEach(function (cb) {
      items.push('<li class="ans-pills__item"><a href="#" class="ans-pill" data-ans-chip-key="' +
        escaparHTML(cb.getAttribute('data-ans-key') || '') + '"><span class="ans-pill__value">' +
        escaparHTML(etiquetaDeCheckbox(cb)) + '</span><span class="ans-pill__x" aria-hidden="true">&times;</span></a></li>');
    });
    var pmin = $('#ans-facets input[data-ans-price-input="min"]');
    var pmax = $('#ans-facets input[data-ans-price-input="max"]');
    if ((pmin && pmin.value) || (pmax && pmax.value)) {
      var pref = (barra.getAttribute('data-ans-price-prefix') || '$');   // no crítico; '$' por defecto
      items.push('<li class="ans-pills__item"><a href="#" class="ans-pill" data-ans-chip-precio><span class="ans-pill__value">' +
        escaparHTML(pref + (pmin && pmin.value || '0') + ' – ' + pref + (pmax && pmax.value || '')) +
        '</span><span class="ans-pill__x" aria-hidden="true">&times;</span></a></li>');
    }
    if (!items.length) { barra.innerHTML = ''; barra.classList.remove('tiene-chips'); return; }
    /* "Borrar todo" al FINAL, igual que la fila del cajón (link gris discreto, opción C).
     * No construye URL: desmarca todos + limpia precio + aplica, idéntico a quitar los chips
     * uno por uno hasta cero (mismo camino que el chip individual). Ver manejador data-ans-chip-clear. */
    items.push('<li class="ans-pills__item"><a href="#" class="ans-pill ans-pill--clear-all" data-ans-chip-clear>Borrar todo</a></li>');
    barra.innerHTML = '<ul class="ans-pills__list" role="list">' + items.join('') + '</ul>';
    barra.classList.add('tiene-chips');
  }

  // --- Estado de carga ------------------------------------------------------

  /* Sin overlay de pantalla completa a propósito: encarece la percepción de
   * velocidad, y la condición 3 de Enrique es "igual de rápido o más rápido". */
  function marcarCargando(cargando) {
    var panel = $('#ans-facets');
    if (panel) panel.setAttribute('aria-busy', cargando ? 'true' : 'false');
    var grid = $('#ans-grid');
    if (grid) grid.classList.toggle('ans-grid--cargando', cargando);
  }

  /* La cadena viene del Liquid (`data-ans-plantilla-conteo`), no clavada aquí:
   * es la única señal que recibe un lector de pantalla tras filtrar, y un .js
   * no puede resolver `| t`. El respaldo cubre el caso de que el atributo
   * falte, para no anunciar un número pelado sin unidad. */
  function anunciar(cuenta) {
    var vivo = $('[data-ans-live]');
    if (!vivo || cuenta === null || cuenta === undefined) return;
    var panel = $('#ans-facets');
    var plantilla = (panel && panel.getAttribute('data-ans-plantilla-conteo')) || '__N__';
    vivo.textContent = plantilla.replace('__N__', cuenta);
  }

  // --- El render ------------------------------------------------------------

  /* ABANDONAR EL ORDEN PROPIO — un solo gesto (24-ago-2026).
   *
   * Renunciar al orden propio y DECIRLO en la etiqueta tienen que ser lo mismo. Mientras
   * fueron dos pasos, se olvidó uno: con el worker caído el grid caía al render nativo (orden
   * del servidor) y el desplegable seguía anunciando "Mayor descuento". La clienta leía un
   * orden y veía otro — el defecto que Enrique ya había cazado el 12-ago, reaparecido por otro
   * camino. Lo destapó `sim/bucle-recarga-vivo.cjs`, no una revisión a ojo.
   *
   * Todo camino que deje de aplicar el orden propio pasa por aquí. */
  function abandonarOrdenPropio(motivo) {
    console.warn('[ans-facets] orden propio abandonado (' + motivo + '); se muestra el orden del servidor');
    restaurarOrdenDelServidor();
  }
  /* ── NAVEGAR COMO RED: sólo cuando navegar SIGNIFIQUE algo (24-ago-2026) ──────
   *
   * BUCLE DE RECARGA que reportó Enrique: los correos de campaña mandan a
   * `/collections/descuento?sort_by=sale-descending` y algunas clientas veían la página
   * recargarse sin parar. Reproducido de forma determinista (`sim/bucle-recarga.cjs`):
   *
   *   worker no responde  → renderOrdenPropioWorker devuelve false
   *   /orden no responde  → renderOrdenPropioCatalogo lanza → cae a render(urlDestino)
   *   ?sections= falla    → render lanza → location.assign(urlDestino)
   *   …y urlDestino ES ESTA MISMA URL, así que el ciclo vuelve a empezar. Sin fin.
   *
   * La causa NO es el orden propio ni el worker: es que la RED DE SEGURIDAD navegaba a la URL
   * en la que YA estaba. Eso no es degradar, es REINTENTAR — y reintentar lo mismo que acaba
   * de fallar, con la misma red rota, sólo puede volver a fallar. Con un orden NATIVO el
   * reintento pasa desapercibido (el servidor sí sabe pintar esa URL, así que la recarga
   * termina el trabajo); con un orden PROPIO el servidor no puede honrarla, el módulo vuelve a
   * arrancar el mismo camino y el bucle se cierra sobre sí mismo.
   *
   * El invariante que lo mata por diseño, para CUALQUIER motivo de fallo presente o futuro:
   *
   *     una red de seguridad no puede REPETIR una operación que va a fallar igual.
   *
   * En la práctica: puede navegar si el destino es otro sitio, o si el servidor puede honrarlo
   * (entonces la recarga termina el trabajo y no se repite). Lo que nunca hace es recargar la
   * misma URL que el servidor NO puede pintar, porque eso reinicia el mismo camino roto.
   *
   * Si el destino es donde ya estamos, no se navega: se degrada EN EL SITIO — se revela lo que
   * el servidor ya pintó y se avisa. La clienta ve productos (en el orden del servidor, no en
   * el suyo), UNA vez, sin parpadeo. Peor que el orden bueno; incomparablemente mejor que una
   * página que no termina de cargar nunca.
   *
   * Pasa por aquí TODA navegación de respaldo del módulo, así que una que se agregue mañana
   * hereda la guarda sin que nadie tenga que acordarse. Las de paginación van a OTRA URL, así
   * que siguen navegando igual que siempre. */
  function navegarComoRed(destino, motivo) {
    /* Los dos lados se normalizan IGUAL (24-ago, auditoría externa). Antes se comparaba el
     * `location.search` crudo contra un destino ya pasado por `URL`, y las dos formas no siempre
     * coinciden: una URL de campaña con `utm_campaign=verano%20geles` se reserializa como
     * `verano+geles`, así que la primera pasada creía estar yendo a "otro sitio" y recargaba una
     * vez de más. No era un bucle —la serialización converge—, pero desmentía el "una vez, sin
     * parpadeo" justo en las URLs del incidente. Comparar dos cosas exige medirlas con la misma
     * vara: si sólo un lado pasa por el normalizador, se comparan dos vocabularios distintos. */
    var norm = function (p, s) {
      try { return p + (s ? '?' + new URLSearchParams(s).toString() : ''); } catch (e) { return p + (s || ''); }
    };
    var aqui = norm(window.location.pathname, window.location.search);
    var alla = destino;
    try { var u = new URL(destino, window.location.origin); alla = norm(u.pathname, u.search); } catch (e) { /* destino raro: se compara crudo */ }

    /* AFINADO tras la auditoría externa (24-ago): la primera versión sólo miraba si el destino
     * era otro sitio, y con eso apagaba también la recuperación de los caminos NATIVOS. Ahí
     * recargar NO es reintentar lo mismo: el servidor SÍ sabe pintar esa URL, así que la recarga
     * termina el trabajo (es el camino que existía antes de este arreglo). Sin este matiz, un
     * fallo pasajero al aplicar un filtro dejaba la rejilla VIEJA con la URL y los chips NUEVOS
     * — y `ultimoRender` ya sembrado, así que ni el Atrás lo curaba.
     *
     * El invariante correcto no es "no navegues a donde ya estás", es: NO REPITAS UNA OPERACIÓN
     * QUE VA A FALLAR IGUAL. Recargar sólo se repite cuando el servidor no puede honrar la URL,
     * porque entonces el módulo vuelve a arrancar el mismo camino roto. */
    var recargarSirve = servidorPudoHonrar(alla.indexOf('?') === -1 ? '' : alla.slice(alla.indexOf('?')));
    if (alla !== aqui || recargarSirve) {   // otro sitio, o una recarga que sí termina el trabajo
      console.warn('[ans-facets] ' + motivo + '; navegando a ' + alla);
      window.location.assign(destino);
      return true;
    }

    /* Mismo sitio: recargar repetiría el fallo. Se degrada aquí y se avisa FUERTE (error, no
     * warn): quedarse con el orden del servidor es una degradación de verdad, que alguien tiene
     * que poder ver en los registros — no un detalle. */
    console.error('[ans-facets] ' + motivo +
                  '; NO se recarga (el destino es esta misma URL: recargar volvería a fallar igual). ' +
                  'Se deja lo que el servidor ya pintó.');
    marcarCargando(false);
    /* Revelar: el CSS esconde el grid mientras se espera el orden propio. Sin esto la clienta se
     * queda mirando un hueco hasta que salte la red de 4 s del snippet. */
    document.documentElement.classList.add('ans-orden-listo');
    document.documentElement.classList.add('ans-filtros-listo');
    /* Y que la etiqueta no MIENTA: el desplegable dice "Mayor descuento" porque
     * `sincronizarOrdenConUrl` lo puso desde la URL, pero lo que se ve es el orden del SERVIDOR.
     * Dejarlo así es el mismo defecto que Enrique cazó el 12-ago (la etiqueta decía una cosa y el
     * grid mostraba otra). Se devuelve al valor con el que llegó del servidor. */
    restaurarOrdenDelServidor();
    return false;
  }

  function render(urlDestino) {
    var url = new URL(urlDestino, window.location.origin);

    /* El id sale del DOM en cada render (ver `resolverSeccion`). Si no se puede
     * resolver, se navega de verdad en vez de pedir una sección inventada: la
     * clienta pierde la fluidez, nunca el resultado. */
    var seccion = resolverSeccion();
    if (!seccion) {
      navegarComoRed(urlDestino, 'no se pudo resolver el id de la sección');
      return Promise.resolve();
    }

    /* La base sale de `location.pathname`, no de '/', para que un día con
     * locales (/es-mx/collections/…) siga funcionando sin cambios — es la
     * recomendación explícita de la doc de Section Rendering API. */
    var separador = url.search ? '&' : '?';
    var urlFetch = url.pathname + url.search + separador +
                   'sections=' + encodeURIComponent(seccion);

    if (peticionEnCurso) peticionEnCurso.abort();
    peticionEnCurso = new AbortController();
    var senal = peticionEnCurso.signal;

    var estado = capturarEstado();
    marcarCargando(true);

    /* SIN cabecera `Accept` — MEDIDO, NO SUPUESTO (jul 20 2026).
     *
     * Aquí iba `headers: {'Accept': 'application/json'}`, que parecía inofensivo
     * y era el segundo motivo por el que la actualización sin recargar nunca
     * funcionó. Con esa cabecera, `/collections/<handle>` sirve el JSON HEREDADO
     * del recurso colección (`{"collection":{…}}`) e IGNORA el parámetro
     * `sections`: 200 OK, `content-type: application/json`, y ni rastro de la
     * sección. Medido en el navegador contra esta misma tienda:
     *   sin Accept              -> claves ["template--22157793362174__main"]  ✅
     *   Accept: application/json -> claves ["collection"]                      ❌
     *   Accept: text/html        -> claves ["template--22157793362174__main"]  ✅
     * La Section Rendering API se activa por el parámetro `sections`, no por la
     * cabecera; pedir JSON explícitamente activa OTRO endpoint que gana. Los
     * temas oficiales hacen `fetch(url)` pelado, y por eso no lo sufren. */
    return fetch(urlFetch, { signal: senal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var html = json[seccion];
        /* El error NOMBRA lo que llegó. Antes decía solo "no trae la sección" y
         * el catch navegaba: el fallo se veía como "es un poco lento", no como
         * un fallo. Con las claves recibidas, la causa salta a la vista. */
        if (!html) {
          throw new Error('La respuesta no trae la sección "' + seccion +
            '". Claves recibidas: ' + Object.keys(json).join(', '));
        }
        var docNuevo = new DOMParser().parseFromString(html, 'text/html');
        var cuenta = intercambiarNodos(docNuevo);
        restaurarEstado(estado);
        construirSliders();   // el panel se reemplazó: reconstruir el slider de precio
        anunciar(cuenta); sincronizarChips();
        reengancharObservador();   // grid nuevo → re-observa el sentinel de paginación para el auto-scroll
        marcarCargando(false);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // abortada a propósito
        marcarCargando(false);
        /* DEGRADACIÓN, NUNCA REJILLA VACÍA: si el render sin recarga falla
         * (red, respuesta rara, sección renombrada), se navega de verdad a la
         * misma URL. La clienta pierde la fluidez, no el resultado. */
        navegarComoRed(urlDestino, 'render sin recarga falló: ' + ((err && err.message) || err));
      });
  }

  // --- Aplicar (§2.5) -------------------------------------------------------

  function aplicar(params) {
    var query = params.toString();
    var url = window.location.pathname + (query ? '?' + query : '');

    if (!navegandoPorHistorial) {
      history.pushState({ ans: query }, '', url);
    }
    ultimoRender = query ? '?' + query : '';
    return despacharRender(params, url);
  }

  /* UN SOLO DESPACHADOR — fix de clase del 12-ago-2026.
   *
   * Esta decisión ("¿qué motor pinta esta URL?") vivía DENTRO de `aplicar`. Cuando se
   * agregó el render inicial para los órdenes propios, llamó a `render()` — la ruta
   * nativa — y se saltó el motor sin que nada lo notara: la etiqueta decía "Mayor
   * descuento" y el grid venía en el orden por defecto.
   *
   * Con la decisión en UN solo lugar, cualquier entrada nueva (init, popstate, chips,
   * lo que venga) despacha igual, y un motor que se agregue aquí queda disponible para
   * todas de una vez. Duplicar un `if` de despacho es exactamente cómo dos caminos que
   * deberían coincidir se separan en silencio. */
  function despacharRender(params, url) {
    if (ANS_SEARCH_WORKER_GRID && esBusqueda()) return renderBusquedaWorker(params);   // /search → motor del worker
    if (esOrdenPropio(params.get('sort_by'))) return renderOrdenPropio(params);        // Mayor descuento → worker /orden
    return render(url);                                                                // el resto lo pinta Shopify
  }

  function esBusqueda() { return /\/search\b/.test(window.location.pathname); }

  function aplicarPorURL(href) {
    /* Los chips y "Borrar todo" NO construyen su URL: la LEEN del `href` que
     * generó Shopify (`url_to_remove`). Así el cliente no puede derivar del
     * cálculo del servidor. Solo se le quita `page`. */
    var url = new URL(href, window.location.origin);
    var params = new URLSearchParams(url.search);
    params.delete('page');
    return aplicar(params);
  }

  // --- Orden PROPIO (Mayor descuento): render por handles del worker + paginación client-side ----------------
  /* Shopify no ordena por descuento; el worker /orden da el orden GLOBAL de la colección (por % de dcto). Aquí se
   * traen TODAS las cards del estado FILTRADO (Section Rendering: página 1, y el resto en PARALELO), se reordenan
   * por ese orden (intersección: solo las del set filtrado) y se paginan del lado del cliente. También se actualiza
   * el panel (conteos del estado filtrado) desde la página 1. ADITIVO y con RED: cualquier fallo → render() nativo,
   * NUNCA deja el grid roto. Solo se activa cuando sort_by ∈ ANS_ORDENES_PROPIOS (el resto de sorts no cambia). */
  var TAM_PAGINA_PROPIO = 60;   // cards por "página" client-side del set reordenado
  /* La PRIMERA página es más corta a propósito. Medido el 12-ago: el grid está OCULTO hasta que el orden bueno
   * está pintado, así que lo que la clienta espera es exactamente "transferir + pintar N cards" — y arriba del
   * pliegue sólo caben ~12. Pedir 60 la hacía esperar por 48 que no iba a ver. Las siguientes sí van de 60
   * (viajan adelantadas, cuando el navegador está ocioso: su tamaño no le cuesta espera a nadie). */
  var TAM_PRIMERA_PROPIO = 24;
  var MAX_PAGINAS_FETCH = 20;   // tope de seguridad al traer todas las páginas (WARN visible si se toca)

  function esOrdenPropio(v) { for (var i = 0; i < ANS_ORDENES_PROPIOS.length; i++) { if (ANS_ORDENES_PROPIOS[i].valor === v) return true; } return false; }
  function coleccionActual() { var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/); return m ? m[1] : null; }
  /* El origen del worker viene del <head> (`window.ANS_WORKER`), no de olfatear un <script> del documento.
   * Esa deducción ataba una constante a la POSICIÓN de una etiqueta: los <script> del worker viven al final
   * del body, así que en cuanto este módulo dejó de esperar a que la página entera se analizara, `workerBase()`
   * devolvía cadena vacía y el orden propio se caía al render nativo — el grid se veía bien, con el orden
   * EQUIVOCADO y sin un solo error en consola. Se conserva el olfateo como respaldo por si el layout no
   * declara la global. `sim/adelanto-datos.mjs` verifica que el origen del <head> y el del layout coincidan. */
  function workerBase() {
    if (window.ANS_WORKER) return window.ANS_WORKER;
    var s = document.querySelector('script[src*="/badges.js"], script[src*="/widget.js"]');
    try { return s ? new URL(s.src).origin : ''; } catch (e) { return ''; }
  }
  function handleDeCard(nodo) { var a = nodo.querySelector('a[href*="/products/"]'); if (!a) return ''; var h = (a.getAttribute('href') || '').split('/products/')[1] || ''; return h.split('?')[0].split('#')[0].replace(/\/+$/, ''); }

  function fetchOrden(col, by) {
    var base = workerBase(); if (!base) return Promise.resolve(null);
    return fetch(base + '/orden?col=' + encodeURIComponent(col) + '&by=' + encodeURIComponent(by))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.handles && j.handles.length) ? j.handles : null; })
      .catch(function () { return null; });
  }

  /* UNA PETICIÓN por página: el worker filtra, ordena y devuelve las cards YA renderizadas (las mismas
   * secciones del tema que usa /search en producción). Antes el navegador se bajaba el catálogo ENTERO de la
   * colección sólo para poder reordenarlo — 665 KB en gc-nails (255 productos), creciendo ~2.6 KB por
   * producto: un costo que pagaba la clienta y que escalaba con el catálogo. Ahora el costo es proporcional
   * a lo que se MUESTRA. El worker declara `soportado:false` cuando NO puede jurar que su set sea el que
   * Shopify mostraría (un filtro que no sabe aplicar, un orden nativo, la colección sin índice) — la decisión
   * vive donde vive el conocimiento, no en una lista aquí que se quedaría atrás. */
  /* Cards que YA están pintadas en la página (las que Shopify sirvió server-side). Son gratis: pedirlas otra
   * vez al worker fue el error medido el 12-ago —157 KB de cosas que ya estaban en pantalla, y el grid
   * tardando MÁS que antes—. Se declaran al worker con `omitir` y él manda sólo lo que falta.
   * Sólo valen cuando el DOM corresponde al set pedido: con filtros en la URL, el DOM ya no corresponde. */
  function cardsYaEnPantalla(params) {
    var mapa = Object.create(null);
    var sinFiltros = true;
    params.forEach(function (v, k) { if (k.slice(0, 7) === 'filter.') sinFiltros = false; });
    if (!sinFiltros) return mapa;
    var grid = document.getElementById('ans-grid'); if (!grid) return mapa;
    [].slice.call(grid.querySelectorAll('.tt-col-item')).forEach(function (c) {
      var h = handleDeCard(c); if (h && !mapa[h]) mapa[h] = c.outerHTML;
    });
    return mapa;
  }

  /* El adelanto del <head> se consume SÓLO si su URL coincide con la que este módulo pediría (sin `omitir`,
   * que allí no se podía calcular). Se compara la URL entera a propósito: cualquier divergencia futura —otro
   * tamaño de página, un parámetro nuevo, otro origen— hace que NO case y se pida normal. Se pierde la ventaja
   * y se nota en la medición; lo que nunca puede pasar es pintar con datos de otra consulta. Se consume una
   * sola vez (un segundo render, ya con filtros, no puede reusar la respuesta del primero). */
  function tomarAdelanto(base, params) {
    var a = window.__ansAdelanto;
    if (window.__ansAdelantoUsado == null) window.__ansAdelantoUsado = false;
    if (!a || !a.promesa) return null;
    var mia = urlColeccion(base, params, 1, null, TAM_PRIMERA_PROPIO);
    if (a.url !== mia) return null;
    window.__ansAdelanto = null;
    /* Marca OBSERVABLE de que el adelanto sirvió. Existe para que la prueba verifique el RESULTADO —que la
     * petición temprana se aprovechó— y no que dos trozos de texto se parezcan. Si un cambio futuro separa las
     * dos URLs, esto queda en false y la prueba truena; sin la marca, la optimización se apagaría en silencio
     * y sólo se notaría como "otra vez se siente lento", que es justo lo que no queremos volver a vivir. */
    window.__ansAdelantoUsado = true;
    return a.promesa.then(function (d) { return normalizarColeccion(d, null); });
  }

  function urlColeccion(base, params, page, yaTengo, size) {
    var qs = new URLSearchParams(params);
    qs.delete('page'); qs.delete('sections'); qs.delete('options[prefix]');
    var by = qs.get('sort_by') || ''; qs.delete('sort_by');
    qs.set('col', coleccionActual() || ''); qs.set('by', by);
    qs.set('page', String(page)); qs.set('size', String(size || TAM_PAGINA_PROPIO)); qs.set('cards', '1');
    var tengo = Object.keys(yaTengo || {});
    if (tengo.length) qs.set('omitir', tengo.join(','));
    return base + '/coleccion?' + qs.toString();
  }

  /* Rellena los huecos que el worker dejó a propósito (`omitir`) con lo que ya estaba en pantalla, y JUZGA la
   * completitud aquí — no en el worker, que no sabe qué tiene el navegador. Compartida por el camino normal y
   * por el adelanto: si cada uno juzgara por su cuenta, uno de los dos se quedaría atrás. */
  function normalizarColeccion(d, yaTengo) {
    if (!d || !d.soportado) return d;
    d.cards = (d.cards || []).map(function (html, i) { return html || (yaTengo || {})[d.handles[i]] || ''; });
    d.cardsCompletas = d.cardsCompletas && d.cards.length === d.handles.length && d.cards.every(function (h) { return !!h; });
    return d;
  }

  function fetchColeccion(base, params, page, yaTengo, size) {
    return fetch(urlColeccion(base, params, page, yaTengo, size))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return normalizarColeccion(d, yaTengo); });
  }

  function fetchTodasLasCards(pFiltro, seccion) {
    /* NO PEDIR LO QUE YA ESTÁ EN PANTALLA (12-ago-2026, lo reportó Enrique como lentitud).
     *
     * Medido en su URL: el orden propio movía 301 KB, y 208 de ellos eran RE-PEDIR la
     * página 1 que el servidor acababa de pintar — el 69% del tráfico, tirado. Las cards
     * ya están en el DOM; lo único que falta es el ORDEN, y ese lo da el worker.
     *
     * Solo se reusa cuando el DOM corresponde de verdad al set pedido: sin filtros en la
     * URL, la página 1 que pintó el servidor ES la página 1 sin filtrar. Con filtros
     * puestos el DOM ya no corresponde y se pide como siempre. La condición se DERIVA de
     * los parámetros, no de una bandera que alguien tenga que acordarse de poner.
     *
     * El ORDEN del DOM da igual: de aquí solo salen las cards para el mapa; quien ordena
     * es el worker. */
    function paginaUnoDelDom() {
      if (pFiltro.toString()) return null;               // hay filtros: el DOM no sirve
      var grid = document.getElementById('ans-grid');
      if (!grid) return null;
      var cards = [].slice.call(grid.querySelectorAll('.tt-col-item'));
      if (!cards.length) return null;
      var tot = parseInt(grid.getAttribute('data-ans-count'), 10);
      return { total: isNaN(tot) ? cards.length : tot, cards: cards, doc: document };
    }
    function pagina(pg) {
      if (pg === 1) {
        var delDom = paginaUnoDelDom();
        if (delDom) return Promise.resolve(delDom);
      }
      var qs = pFiltro.toString();
      var url = window.location.pathname + '?' + (qs ? qs + '&' : '') + 'page=' + pg + '&sections=' + encodeURIComponent(seccion);
      return fetch(url).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).then(function (json) {
        var html = json[seccion]; if (!html) throw new Error('sin seccion');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.getElementById('ans-grid');
        var tot = grid ? parseInt(grid.getAttribute('data-ans-count'), 10) : NaN;
        var cards = grid ? [].slice.call(grid.querySelectorAll('.tt-col-item')) : [];
        return { total: tot, cards: cards, doc: doc };
      });
    }
    var mapa = Object.create(null);
    function juntar(cards) { cards.forEach(function (c) { var h = handleDeCard(c); if (h && !mapa[h]) mapa[h] = c.outerHTML; }); }
    return pagina(1).then(function (p1) {
      juntar(p1.cards);
      var porPag = p1.cards.length || TAM_PAGINA_PROPIO;
      var total = (!isNaN(p1.total)) ? p1.total : p1.cards.length;
      var nPag = Math.min(Math.max(1, Math.ceil(total / porPag)), MAX_PAGINAS_FETCH);
      if (nPag <= 1 || p1.cards.length === 0) return { mapa: mapa, doc: p1.doc };
      var pend = [];
      for (var pg = 2; pg <= nPag; pg++) pend.push(pagina(pg).catch(function () { return { cards: [] }; }));
      return Promise.all(pend).then(function (paginas) {
        paginas.forEach(function (pp) { juntar(pp.cards); });
        if (nPag >= MAX_PAGINAS_FETCH && Object.keys(mapa).length < total) console.warn('[ans-facets] orden propio: tope ' + MAX_PAGINAS_FETCH + ' págs; ' + Object.keys(mapa).length + '/' + total);
        return { mapa: mapa, doc: p1.doc };
      });
    });
  }

  /* PROVEEDOR del siguiente lote del orden propio. Hay DOS orígenes posibles —el worker (una petición por
   * página) y el set completo ya en memoria (la RED, cuando el worker no puede jurar el set)— y viven detrás
   * de UNA interfaz para que el auto-scroll no tenga que saber cuál está activo. Sin esta costura, cada
   * origen nuevo obligaría a tocar el manejador del scroll, que es justo donde un olvido no se nota.
   * Contrato: `siguiente()` → Promise<[htmlCard]> (vacío = ya no hay) · `hayMas()` → bool. */
  var proveedorPropio = null;

  function proveedorEnMemoria(cards) {
    var resto = cards.slice(TAM_PAGINA_PROPIO);
    return {
      hayMas: function () { return resto.length > 0; },
      siguiente: function () { var lote = resto.slice(0, TAM_PAGINA_PROPIO); resto = resto.slice(TAM_PAGINA_PROPIO); return Promise.resolve(lote); }
    };
  }

  /* Proveedor por worker: pide la página N y ADELANTA la N+1 en segundo plano apenas pinta la anterior.
   * El prefetch es el que conserva el scroll INSTANTÁNEO de antes: cuando la clienta llega al fondo, el lote
   * ya está en memoria y no espera red. Si el prefetch falla, `siguiente()` reintenta en vivo (nunca se
   * queda sin más productos por un fallo de adelanto). */
  function proveedorWorker(base, params, total, entregadas) {
    /* La página 1 fue de TAM_PRIMERA_PROPIO y las siguientes son de TAM_PAGINA_PROPIO, así que el "siguiente"
     * no es page 2: se calcula el desplazamiento REAL ya entregado y de ahí sale la página que toca. Derivarlo
     * de lo entregado —en vez de llevar un contador aparte— hace imposible el hueco o el repetido si mañana
     * cambia cualquiera de los dos tamaños. */
    var adelanto = null;
    var siguientePagina = function () { return Math.floor(entregadas / TAM_PAGINA_PROPIO) + 1; };
    var quedan = function () { return entregadas < total; };
    // Sin `yaTengo`: de la página 2 en adelante el grid ya es el nuevo, no queda nada del server-render que reusar.
    function pedir(p) { return fetchColeccion(base, params, p, null, TAM_PAGINA_PROPIO).then(function (d) { return (d && d.soportado && d.cardsCompletas) ? d.cards.slice(entregadas - (p - 1) * TAM_PAGINA_PROPIO) : []; }).catch(function () { return []; }); }
    /* El adelanto NO sale junto con el primer pintado: competiría por el ancho de banda con justo lo que la
     * clienta está esperando ver. Se lanza cuando el navegador queda ocioso, así el scroll sigue siendo
     * instantáneo sin robarle velocidad a la primera pantalla. */
    function adelantar() {
      if (!quedan()) return;
      var lanzar = function () { adelanto = pedir(siguientePagina()); };
      if (typeof requestIdleCallback === 'function') requestIdleCallback(lanzar, { timeout: 2000 });
      else setTimeout(lanzar, 800);
    }
    adelantar();
    return {
      hayMas: quedan,
      siguiente: function () {
        if (!quedan()) return Promise.resolve([]);
        var p = adelanto || pedir(siguientePagina());
        adelanto = null;
        return p.then(function (cards) {
          if (!cards.length) { entregadas = total; return []; }   // sin lote → no hay más (y el botón se apaga)
          entregadas += cards.length;
          adelantar();
          return cards;
        });
      }
    };
  }

  function pintarBotonMas() {
    var pag = $(SEL_PAGINACION) || $(SEL_PAGINACION_RESPALDO); if (!pag) return;
    if (!proveedorPropio || !proveedorPropio.hayMas()) { pag.innerHTML = ''; pag.classList.add('hide'); return; }
    pag.classList.remove('hide');
    /* El auto-scroll (IntersectionObserver) observa ESTE nodo y carga sola 600 px antes de llegar; el CSS lo
     * esconde con `.ans-scroll-infinito`. El botón sólo se ve —y sólo hay que pulsarlo— en un navegador sin
     * IntersectionObserver. La clienta no gana un paso: es la misma red que ya existía. */
    pag.innerHTML = '<div class="show-more"><a href="#" class="btn btn-border ttshowmorestyle" data-ans-mas-propio>' + (window.ANS_TXT_MAS || 'Mostrar más') + '</a></div>';
  }
  var cargandoMasPropio = false;
  function cargarMasPropio() {
    var grid = $('#ans-grid');
    if (!grid || cargandoMasPropio || !proveedorPropio || !proveedorPropio.hayMas()) return;
    cargandoMasPropio = true;
    spinnerMas(true);
    proveedorPropio.siguiente().then(function (lote) {
      if (lote && lote.length) grid.insertAdjacentHTML('beforeend', lote.join(''));
      cargandoMasPropio = false; spinnerMas(false);
      pintarBotonMas();
      reengancharObservador();   // el nodo de paginación se reescribió: el observador tiene que volver a mirarlo
    }).catch(function () { cargandoMasPropio = false; spinnerMas(false); });
  }

  /* Arma la lista del orden propio: primero los handles que /orden listó (en el orden AUTORITATIVO del worker),
   * y los SOBRANTES (que /orden no listó — no debería pasar; el worker devuelve todos) ordenados por su % de
   * descuento en vez de sin ordenar (antes iban crudos al final → un hueco del worker rompía el orden visible).
   * Defensa-en-profundidad. `pctDe` inyectable ⇒ función PURA (testeable sin DOM). */
  function armarOrdenPropio(handles, mapa, pctDe) {
    var vistos = Object.create(null), ordenadas = [];
    (handles || []).forEach(function (h) { if (mapa[h] && !vistos[h]) { vistos[h] = 1; ordenadas.push(mapa[h]); } });
    var sobrantes = Object.keys(mapa).filter(function (h) { return !vistos[h]; });
    sobrantes.sort(function (a, b) { return (pctDe(mapa[b]) - pctDe(mapa[a])) || (a < b ? -1 : a > b ? 1 : 0); });
    sobrantes.forEach(function (h) { ordenadas.push(mapa[h]); });
    return ordenadas;
  }
  // % de descuento leído del HTML de una card (badge "Descuento X%"). Navegador (usa el DOM para no depender de regex frágil).
  function pctDeCardHTML(html) {
    try {
      var d = document.createElement('div'); d.innerHTML = html || '';
      var l = d.querySelector('.tt-label-sale, [class*="label-sale"]');
      var m = l && (l.textContent || '').match(/(\d+)\s*%/);
      return m ? parseInt(m[1], 10) : 0;
    } catch (e) { return 0; }
  }

  /* Pintado FINAL del orden propio — IDÉNTICO para los dos orígenes (worker y catálogo completo). Está
   * extraído a propósito: mientras cada camino pintaba por su cuenta, un paso agregado a uno se olvidaba en
   * el otro, y el defecto sólo asomaba por el camino de respaldo — el que menos se mira y más tarde se caza.
   * `proveedorPropio` debe estar puesto ANTES de llamar (de él sale si hay más páginas). */
  function pintarOrdenPropio(cards, total, estado) {
    var grid = $('#ans-grid'); if (!grid) throw new Error('sin #ans-grid');
    grid.innerHTML = cards.join('');
    grid.setAttribute('data-ans-count', String(total));
    $$('.ans-count-value').forEach(function (n) { n.textContent = String(total); });
    pintarBotonMas();
    restaurarEstado(estado);
    construirSliders();
    anunciar(total); sincronizarChips();
    reengancharObservador();   // orden propio: el auto-scroll observa el nodo de paginación (sin clic de la clienta)
    marcarCargando(false);
    /* REVELAR: el orden bueno ya esta pintado. Va aquí Y en el .catch de más abajo --
     * si el motor falla se revela igual con el orden del servidor, que es peor que el
     * correcto pero infinitamente mejor que una pagina en blanco. La red de 4 s del
     * snippet cubre incluso que este codigo no llegue a correr. */
    document.documentElement.classList.add('ans-orden-listo');
  }

  /* CAMINO RÁPIDO: una petición al worker trae la página que se va a ver, ya filtrada, ordenada y con las
   * cards renderizadas. Devuelve `true` si pintó. Devuelve `false` —sin romper nada— en cuanto algo no da
   * garantías: worker no disponible, set que no puede jurar (`soportado:false`), o cards incompletas (un
   * grid con huecos es PEOR que el camino viejo). Ese `false` es la puerta a la RED de abajo. */
  function renderOrdenPropioWorker(params, estado) {
    var base = workerBase();
    if (!base) return Promise.resolve(false);
    /* ¿El <head> ya pidió esto? El snippet inline lanza la petición en el primer paint (~300 ms), mucho antes
     * de que este archivo exista. Si la URL que YO construiría es la misma que él pidió, se aprovecha su
     * respuesta en vez de empezar de cero — es la diferencia entre esperar desde los 300 ms o desde los 1650.
     * La comparación es por URL COMPLETA (salvo `omitir`, que él no podía saber): si no casa exactamente, se
     * ignora y se pide normal. Nunca se pinta con una respuesta que no corresponde a lo que se está mostrando. */
    var yaTengo = cardsYaEnPantalla(params);   // lo que Shopify ya pintó: gratis, no se vuelve a pedir
    var adelanto = tomarAdelanto(base, params);
    var pedido = adelanto || fetchColeccion(base, params, 1, yaTengo, TAM_PRIMERA_PROPIO);
    return pedido.then(function (d) {
      if (!d || !d.soportado || !d.cardsCompletas || !d.cards.length) return false;
      proveedorPropio = proveedorWorker(base, params, d.total, d.cards.length);
      actualizarPanelDesdeFacetas(d.facetas);   // conteos "(N)" del estado filtrado, mismo primitivo que /facetas
      pintarOrdenPropio(d.cards, d.total, estado);
      return true;
    }).catch(function () { return false; });
  }

  /* RED: el camino de siempre — traerse el catálogo COMPLETO del estado filtrado desde Shopify y reordenarlo
   * aquí. Caro (crece con la colección) pero no depende del índice del worker: es lo que sostiene los casos
   * que el worker no cubre (un filtro que no sabe aplicar, una colección aún sin indexar). */
  function renderOrdenPropioCatalogo(params, col, by, seccion, estado, urlDestino) {
    var pFiltro = new URLSearchParams(params); pFiltro.delete('sort_by'); pFiltro.delete('page');
    return Promise.all([fetchOrden(col, by), fetchTodasLasCards(pFiltro, seccion)])
      .then(function (res) {
        var handles = res[0], data = res[1];
        if (!handles || !data || !Object.keys(data.mapa).length) throw new Error('orden/cards vacío');
        // 1) panel: conteos/valores del estado FILTRADO (desde page-1) — para que filtrar dentro del orden propio actualice el panel
        /* Si la página 1 salió del DOM vivo, `data.doc` ES este documento y el panel
         * "nuevo" sería el mismo nodo: reemplazarlo consigo mismo no aporta nada y sí
         * puede tirar el estado (foco, grupos abiertos). Se salta explícitamente. */
        var panelViejo = $('#ans-facets'), panelNuevo = data.doc && data.doc !== document && $('#ans-facets', data.doc);
        if (panelViejo && panelNuevo && panelNuevo !== panelViejo) panelViejo.parentNode.replaceChild(panelNuevo, panelViejo);
        // 2) grid: cards del set filtrado, en el orden de /orden; los que /orden no listó → ordenados por % al final
        var ordenadas = armarOrdenPropio(handles, data.mapa, pctDeCardHTML);
        proveedorPropio = proveedorEnMemoria(ordenadas);
        pintarOrdenPropio(ordenadas.slice(0, TAM_PAGINA_PROPIO), ordenadas.length, estado);
      })
      .catch(function (err) {
        marcarCargando(false);
        /* REVELAR: el orden bueno ya esta pintado. Va en el .then Y en el .catch --
         * si el motor falla se revela igual con el orden del servidor, que es peor que el
         * correcto pero infinitamente mejor que una pagina en blanco. La red de 4 s del
         * snippet cubre incluso que este codigo no llegue a correr. */
        document.documentElement.classList.add('ans-orden-listo');

        abandonarOrdenPropio('orden propio falló: ' + ((err && err.message) || err));
        return render(urlDestino);   // RED: nunca grid roto (Shopify ignora el sort propio → orden por defecto, pero con productos)
      });
  }

  /* Orden propio, en dos escalones: worker (1 petición, coste proporcional a lo que se ve) y, si no puede
   * jurar el set, el catálogo completo. El tercer escalón —render nativo— vive dentro del segundo. */
  function renderOrdenPropio(params) {
    var col = coleccionActual();
    var by = params.get('sort_by');
    var seccion = resolverSeccion();
    var urlDestino = window.location.pathname + '?' + params.toString();
    if (!col || !seccion) { abandonarOrdenPropio('sin colección o sin sección resoluble'); return render(urlDestino); }
    if (peticionEnCurso) { peticionEnCurso.abort(); peticionEnCurso = null; }
    var estado = capturarEstado();
    marcarCargando(true);
    return renderOrdenPropioWorker(params, estado).then(function (pintado) {
      if (pintado) return;
      return renderOrdenPropioCatalogo(params, col, by, seccion, estado, urlDestino);
    });
  }

  // --- Scroll infinito (append) ---------------------------------------------
  /* El tema está en "showmore" (botón) y su auto-scroll NATIVO lo maneja otro JS que este módulo PREEMPTE
   * (stopPropagation en la paginación) → el infinite-scroll lo implementa AQUÍ: un IntersectionObserver sobre el
   * nodo de paginación auto-carga la siguiente página y la AGREGA (append), igual que el clic del botón. Antes el
   * clic REEMPLAZABA la página (page-by-page: el 1er producto cambiaba); ahora AGREGA. Degrada limpio: sin
   * IntersectionObserver el botón (clic) sigue cargando; ante cualquier error de fetch, navega de verdad. */
  var cargandoMas = false, observadorScroll = null;

  /* Feedback de carga: un spinner al fondo mientras se trae la página siguiente (el botón "Mostrar más" se oculta
   * por CSS cuando el scroll infinito está activo — clase `ans-scroll-infinito` en <html> —, quedando solo como
   * fallback si el navegador no soporta IntersectionObserver). El spinner se ancla como hermano de la paginación:
   * ese nodo se reemplaza en cada append, pero el spinner (su hermano) sobrevive. */
  function asegurarSpinner() {
    if ($('.ans-mas-spinner')) return;
    var pag = $(SEL_PAGINACION) || $(SEL_PAGINACION_RESPALDO);
    if (!pag || !pag.parentNode) return;
    var sp = document.createElement('div');
    sp.className = 'ans-mas-spinner';
    sp.setAttribute('aria-hidden', 'true');
    pag.parentNode.insertBefore(sp, pag.nextSibling);
  }
  function spinnerMas(mostrar) {
    asegurarSpinner();
    var sp = $('.ans-mas-spinner');
    if (sp) sp.classList.toggle('ans-mas-spinner--on', !!mostrar);
    var panel = $('#ans-facets');
    if (panel) panel.setAttribute('aria-busy', mostrar ? 'true' : 'false');   // a11y sin atenuar el grid (eso es para filtrar)
  }

  function urlSiguiente() {
    var a = $(SEL_PAGINACION + ' a[href]') || $(SEL_PAGINACION_RESPALDO + ' a[href]');
    var href = a && a.getAttribute('href');
    return (href && href !== '#') ? href : null;
  }

  function cargarMas() {
    if (cargandoMas) return;
    if ($('[data-ans-mas-busqueda]')) { cargarMasBusqueda(); return; }   // /search worker-driven: siguiente página de /busqueda
    if ($('[data-ans-mas-propio]')) { cargarMasPropio(); reengancharObservador(); return; }   // orden propio: paginación client-side
    var href = urlSiguiente(); if (!href) return;
    var seccion = resolverSeccion();
    if (!seccion) { navegarComoRed(href, 'cargar más: no se pudo resolver la sección'); return; }
    cargandoMas = true;
    // Comparte peticionEnCurso con render(): si la clienta aplica un filtro mientras un append está en vuelo,
    // render() lo ABORTA → nunca se agregan cards de la página vieja al grid nuevo (no se mezclan resultados).
    if (peticionEnCurso) peticionEnCurso.abort();
    peticionEnCurso = new AbortController();
    var senal = peticionEnCurso.signal;
    var url = new URL(href, window.location.origin);
    var urlFetch = url.pathname + url.search + (url.search ? '&' : '?') + 'sections=' + encodeURIComponent(seccion);
    spinnerMas(true);   // spinner al fondo (no se atenúa el grid: el usuario sigue viendo lo ya cargado)
    fetch(urlFetch, { signal: senal }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (json) {
        var htmlSec = json[seccion]; if (!htmlSec) throw new Error('sin sección');
        var doc = new DOMParser().parseFromString(htmlSec, 'text/html');
        var grid = $('#ans-grid'), gridN = doc.getElementById('ans-grid');
        if (grid && gridN) { var frag = document.createDocumentFragment(); [].slice.call(gridN.querySelectorAll('.tt-col-item')).forEach(function (c) { frag.appendChild(c); }); grid.appendChild(frag); }
        var pagV = $(SEL_PAGINACION) || $(SEL_PAGINACION_RESPALDO);
        var pagN = $(SEL_PAGINACION, doc) || $(SEL_PAGINACION_RESPALDO, doc);
        if (pagV && pagN) pagV.parentNode.replaceChild(pagN, pagV);   // apunta a la SIGUIENTE página
        else if (pagV) pagV.remove();                                 // ya no hay más → quita el botón
        // NO se reconstruye el slider de precio: el panel de filtros NO cambia al agregar cards (solo crece el grid).
        spinnerMas(false); cargandoMas = false;
        reengancharObservador();
      })
      .catch(function (err) {
        cargandoMas = false;
        if (err && err.name === 'AbortError') return;   // abortada por un filtro nuevo — NO navegar
        spinnerMas(false);
        navegarComoRed(href, 'cargar más falló: ' + ((err && err.message) || err));
      });
  }

  var observadorPaginacion = null;   // espera SÓLO a que aparezca el nodo de paginación (ver abajo)
  function reengancharObservador() {
    if (observadorScroll) { observadorScroll.disconnect(); observadorScroll = null; }
    if (typeof IntersectionObserver !== 'function') return;   // sin observer → el botón (clic) sigue sirviendo (fallback)
    // JS infinite-scroll disponible → CSS oculta el botón "Mostrar más" activo (deja el "No más productos" del final).
    document.documentElement.classList.add('ans-scroll-infinito');
    var pag = $(SEL_PAGINACION) || $(SEL_PAGINACION_RESPALDO);
    /* La paginación se emite DESPUÉS de las cards del servidor: cuando el módulo arranca temprano (que es lo
     * que queremos) todavía no está en el DOM. En vez de esperarla —lo que retrasaría el render entero— se
     * espera SÓLO para esto: en cuanto aparece, se vuelve a enganchar. Sin esto, arrancar temprano dejaba el
     * scroll infinito muerto y no se notaba hasta que la clienta llegaba al fondo y no pasaba nada. */
    if (!pag && document.readyState === 'loading' && typeof MutationObserver === 'function' && !observadorPaginacion) {
      observadorPaginacion = new MutationObserver(function () {
        if ($(SEL_PAGINACION) || $(SEL_PAGINACION_RESPALDO)) {
          observadorPaginacion.disconnect(); observadorPaginacion = null;
          reengancharObservador();
        }
      });
      observadorPaginacion.observe(document.documentElement, { childList: true, subtree: true });
    }
    asegurarSpinner();
    if (!pag || (!urlSiguiente() && !$('[data-ans-mas-propio]') && !$('[data-ans-mas-busqueda]'))) { spinnerMas(false); return; }   // no hay más → no observa
    observadorScroll = new IntersectionObserver(function (ents) { ents.forEach(function (e) { if (e.isIntersecting) cargarMas(); }); }, { rootMargin: '600px 0px' });
    observadorScroll.observe(pag);
  }

  // --- Enganche de eventos (§2.3) -------------------------------------------

  /* TODO por delegación en `document`, no un listener por opción. Motivo: el
   * panel se REEMPLAZA entero en cada render; cualquier listener colgado de un
   * input concreto moriría con el primer filtro aplicado y el segundo clic no
   * haría nada. Delegar en document sobrevive a todos los swaps. */
  function engancharEventos() {

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.id !== 'ans-facets-form' && !form.classList.contains('ans-sort--standalone')) return;
      e.preventDefault();
      aplicar(parametrosDesdeForm(form));
    });

    document.addEventListener('change', function (e) {
      var control = e.target;
      if (!control.matches('#ans-facets input, #ans-facets select, [data-ans-sort]')) return;
      // Los inputs de precio se tratan en 'input' con debounce, no aquí.
      if (control.type === 'number') return;
      var form = obtenerForm();
      if (!form) return;
      /* AUTO-CERRAR el cajón MÓVIL al APLICAR un filtro (Enrique jul 29 2026): un checkbox que se MARCA (activa un
       * filtro) cierra el cajón para que la clienta vea el resultado; DESmarcar (quitar) lo deja ABIERTO para poner
       * otro (decisión de Enrique). El PRECIO (type=number) ya salió arriba → nunca cierra (rango continuo). El ORDEN
       * ([data-ans-sort]/select) no es un filtro → no cierra. SOLO móvil: `ans-drawer-abierto` nunca está en
       * escritorio (ahí el panel es sidebar fijo).
       * Se cierra ANTES de aplicar(): el render de colección llama capturarEstado→restaurarEstado, que RE-ABRIRÍA el
       * cajón si estuviera abierto al capturar; cerrándolo primero, captura el estado CERRADO y no lo re-abre (ni
       * flashea). El grid/filtro se aplican igual (cerrar el <details> no descheck ni cambia el form). */
      if (control.type === 'checkbox' && control.checked && document.body.classList.contains('ans-drawer-abierto')) {
        var cajon = $('#ans-drawer');
        if (cajon) cajon.open = false;
      }
      aplicar(parametrosDesdeForm(form));
    });

    document.addEventListener('input', function (e) {
      var control = e.target;
      if (!control.matches('#ans-facets input[type="number"]')) return;
      /* Debounce: sin él, teclear "1500" dispararía 4 renders y 3 abortos.
       * 400 ms es el umbral por debajo del cual se sigue percibiendo inmediato. */
      clearTimeout(temporizadorPrecio);
      temporizadorPrecio = setTimeout(function () {
        var form = obtenerForm();
        if (form) aplicar(parametrosDesdeForm(form));
      }, DEBOUNCE_PRECIO_MS);
    });

    document.addEventListener('click', function (e) {
      // "Mostrar más" del ORDEN PROPIO (paginación client-side del set reordenado). ANTES del manejador de
      // paginación nativa (más abajo): mi botón vive dentro de [data-ans-pagination] y también casaría con él.
      var masPropio = e.target.closest('[data-ans-mas-propio]');
      if (masPropio) { e.preventDefault(); e.stopPropagation(); cargarMasPropio(); return; }

      // Chips, "Borrar" por grupo y "Borrar todo".
      var quitar = e.target.closest('[data-ans-remove]');
      if (quitar && quitar.getAttribute('href')) {
        e.preventDefault();
        aplicarPorURL(quitar.getAttribute('href'));
        return;
      }

      // Chip de la BARRA (móvil): quita SU filtro desmarcando el checkbox del cajón (o limpiando el precio) y
      // aplica. El cajón queda cerrado; sincronizarChips (tras el render) redibuja la fila sin ese chip.
      var chipKey = e.target.closest('[data-ans-chip-key]');
      if (chipKey) {
        e.preventDefault();
        var cb = document.querySelector('#ans-facets input[data-ans-key="' + cssEscape(chipKey.getAttribute('data-ans-chip-key')) + '"]');
        var formC = obtenerForm();
        if (cb && formC) { cb.checked = false; aplicar(parametrosDesdeForm(formC)); }
        return;
      }
      var chipPrecio = e.target.closest('[data-ans-chip-precio]');
      if (chipPrecio) {
        e.preventDefault();
        var pmn = $('#ans-facets input[data-ans-price-input="min"]'), pmx = $('#ans-facets input[data-ans-price-input="max"]');
        if (pmn) pmn.value = ''; if (pmx) pmx.value = '';
        var formP = obtenerForm();
        if (formP) aplicar(parametrosDesdeForm(formP));
        return;
      }
      // "Borrar todo" de la BARRA (móvil): desmarca TODOS los checkboxes del cajón + limpia el precio y aplica.
      // Idéntico a quitar los chips uno por uno hasta cero → conserva orden/consulta vía parametrosDesdeForm.
      var chipClear = e.target.closest('[data-ans-chip-clear]');
      if (chipClear) {
        e.preventDefault();
        var formCl = obtenerForm();
        if (formCl) {
          $$('#ans-facets .ans-list__item input[type="checkbox"]:checked').forEach(function (cb) { cb.checked = false; });
          var pmn2 = $('#ans-facets input[data-ans-price-input="min"]'), pmx2 = $('#ans-facets input[data-ans-price-input="max"]');
          if (pmn2) pmn2.value = ''; if (pmx2) pmx2.value = '';
          aplicar(parametrosDesdeForm(formCl));
        }
        return;
      }

      // Plegar / desplegar un grupo.
      var toggle = e.target.closest('.ans-group__toggle');
      if (toggle) {
        e.preventDefault();
        var grupo = toggle.closest('[data-ans-group]');
        var abierto = grupo.classList.toggle('open');
        toggle.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        return;
      }

      // Cerrar el cajón móvil.
      var cerrar = e.target.closest('[data-ans-drawer-close]');
      if (cerrar) {
        var cajon = $('#ans-drawer');
        if (cajon) cajon.open = false;
        /* Si es el CTA del pie (type=submit) se le corta el envío: con JS los
         * filtros ya se aplicaron al vuelo, y enviar el form provocaría una
         * recarga completa innecesaria. Sin JS ese mismo botón SÍ envía, que
         * es justo lo que se quiere. */
        if (cerrar.type === 'submit') e.preventDefault();
        return;
      }

      /* Tap FUERA del panel (en el backdrop) cierra el cajón móvil — PARIDAD GLOBO
       * (Enrique jul 22 2026: Globo cierra al tocar el área atenuada de la derecha; el
       * nuestro solo cerraba con la X o el CTA). El backdrop es el `::before` de
       * `#ans-drawer`, así que un tap ahí tiene como target el propio <details>, NO el
       * `.ans-drawer__panel`. Guarda `body.ans-drawer-abierto`: esa clase se pone SOLO
       * con el cajón MÓVIL abierto (imponerInvariantesCajon la quita en escritorio), así
       * que esto nunca dispara en escritorio ni con el cajón cerrado. */
      if (document.body.classList.contains('ans-drawer-abierto')) {
        var enCajon = e.target.closest('#ans-drawer');
        if (enCajon && !e.target.closest('.ans-drawer__panel')) {
          enCajon.open = false;
          return;
        }
      }

      // "Cargar más" / paginación: conserva `page`.
      var mas = e.target.closest(SEL_PAGINACION + ' a') ||
                e.target.closest(SEL_PAGINACION_RESPALDO + ' a');
      if (mas && mas.getAttribute('href')) {
        e.preventDefault();
        e.stopPropagation(); // preempte el manejador de scroll infinito del tema; el nuestro AGREGA
        cargarMas();         // AGREGA la siguiente página (antes REEMPLAZABA page-by-page)
      }
    }, true); // fase de captura: para ganarle al manejador propio del tema

    /* Bloqueo del scroll del cuerpo mientras el cajón está abierto. `toggle` es
     * el evento nativo de <details>: no hay que interceptar el clic del summary
     * ni duplicar la lógica de apertura, que sigue siendo HTML puro. */
    var cajon = $('#ans-drawer');
    document.addEventListener('toggle', function (e) {
      if (!e.target.matches || !e.target.matches('#ans-drawer')) return;
      document.body.classList.toggle('ans-drawer-abierto', e.target.open);
      /* En escritorio el panel NO es cerrable: si algo lo cierra (una pulsación en
       * el summary que el CSS oculta, el teclado, otro script), se reabre. Ver
       * `imponerInvariantesCajon`. */
      imponerInvariantesCajon();
    }, true);
    if (cajon && cajon.open) document.body.classList.add('ans-drawer-abierto');

    /* Escape cierra el cajón móvil — PARIDAD GLOBO (Enrique jul 22 2026, cazado por la
     * prueba de comportamiento). Guarda `ans-drawer-abierto`: solo con el cajón MÓVIL
     * abierto (en escritorio la clase no está y el panel no es cerrable). */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!document.body.classList.contains('ans-drawer-abierto')) return;
      var c = $('#ans-drawer');
      if (c && c.open) c.open = false;
    });

    /* El invariante se re-impone al cambiar el ancho: girar el teléfono o
     * arrastrar la ventana cruza el punto de corte y el estado correcto cambia. */
    var reimponer;
    window.addEventListener('resize', function () {
      clearTimeout(reimponer);
      reimponer = setTimeout(imponerInvariantesCajon, 150);
    });
    imponerInvariantesCajon();
    /* ANTI-FOUC del panel: el cajón móvil YA está colapsado (imponerInvariantesCajon lo cerró) → revelar. El CSS
     * ocultaba el panel en móvil con `ans-filtros-js:not(.ans-filtros-listo)` para no enseñar el panel EXPANDIDO
     * antes de este punto (pantallazo del hallazgo IMG_7788/7789). A partir de aquí el cajón funciona normal. */
    document.documentElement.classList.add('ans-filtros-listo');

    // Historial (§2.5).
    window.addEventListener('popstate', function (e) {
      /* GUARDA 1 — estado ajeno. Otros componentes del tema (el modal de
       * reseñas) y la entrada inicial del historial también disparan popstate.
       * Sin esta guarda, abrir y cerrar un modal repintaría la rejilla. */
      if (!e.state || e.state.ans === undefined) return;

      /* GUARDA 2 — ya renderizado. Si el DOM ya refleja esta URL no se hace
       * nada. Es la guarda dura: convierte un eventual bucle en un no-op. */
      if (window.location.search === ultimoRender) return;

      /* GUARDA 3 — bandera de reentrada: mientras dure este render NO se llama
       * a pushState (ver `aplicar`). Empujar un estado desde dentro de popstate
       * es el bucle clásico. */
      navegandoPorHistorial = true;
      ultimoRender = window.location.search;
      /* POR EL DESPACHADOR, NO POR LA RUTA NATIVA (24-ago-2026, lo destapó la auditoría externa).
       *
       * Aquí se llamaba a `render()` directo. El comentario de `despacharRender` prometía que
       * «cualquier entrada nueva (init, popstate, chips, lo que venga) despacha igual» — y era
       * FALSO justo para popstate desde que se escribió. Consecuencia medida en el preview:
       * llegar por la campaña, marcar un filtro y pulsar ATRÁS dejaba el grid en el orden del
       * servidor con el desplegable anunciando "Mayor descuento". Es el defecto del 12-ago (la
       * etiqueta dice una cosa y el grid muestra otra) reapareciendo por la puerta del historial,
       * en silencio total: ni un aviso en consola.
       *
       * La lección no es "faltaba una llamada": es que un despachador único sólo vale si NADIE
       * lo puentea. Un `render()` suelto en un camino de entrada es la duplicación que el propio
       * comentario decía estar evitando. */
      Promise.resolve(despacharRender(new URLSearchParams(window.location.search), window.location.href)).then(function () {
        navegandoPorHistorial = false;
      }, function () {
        navegandoPorHistorial = false;
      });
    });
  }

  /* --- El invariante del cajón (jul 20 2026) --------------------------------
   *
   * REGLA: en escritorio el panel está SIEMPRE abierto; en móvil es un cajón que
   * arranca cerrado.
   *
   * Por qué vive en JS y no solo en CSS: el contenido de un <details> cerrado no
   * entra en el layout, y eso el CSS no lo puede revertir (se intentó con
   * `display:block` sobre el hijo y el resultado fue un panel de 269 px dentro de
   * un padre de 0 px — invisible). El atributo `open` es el único interruptor real.
   *
   * El HTML llega con `open` puesto, así que el estado CORRECTO PARA ESCRITORIO ya
   * es el de partida: si este archivo no carga, escritorio se ve igual. Esta función
   * solo añade lo que el HTML estático no puede saber: cuál es el ancho.
   */
  function imponerInvariantesCajon() {
    var cajon = $('#ans-drawer');
    if (!cajon) return;
    /* El punto de corte se LEE del Liquid (`data-ans-escritorio`), no se
     * escribe aquí: estaba en tres sitios (este y las dos @media del CSS) y
     * nadie los sincronizaba. El respaldo solo cubre que falte el atributo. */
    var panel = $('#ans-facets');
    var consulta = (panel && panel.getAttribute('data-ans-escritorio')) || '(min-width: 992px)';
    var escritorio = window.matchMedia(consulta).matches;
    if (escritorio) {
      if (!cajon.open) cajon.open = true;          // no cerrable en escritorio
      document.body.classList.remove('ans-drawer-abierto');
    } else if (!cajonTocadoPorLaClienta) {
      /* Móvil: se cierra para actuar como cajón, PERO solo mientras la clienta no
       * lo haya abierto ella misma. Sin esta condición, un `resize` (teclado en
       * pantalla, barra del navegador al hacer scroll) le cerraría el cajón en la
       * cara mientras lo está usando. */
      if (cajon.open) cajon.open = false;
    }
  }

  /* Se marca en cuanto la clienta interactúa con el cajón, para no pisarle el estado. */
  var cajonTocadoPorLaClienta = false;
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    /* OPENER DE LA BARRA (paridad Globo móvil, jul 22 2026): el <button data-ans-open-drawer>
     * vive en la barra de herramientas, no es un <summary>, así que ABRE el cajón por JS. El
     * <summary> real (columna de filtros) sigue abriendo el cajón por HTML puro sin JS; este
     * botón sólo existe/actúa con JS (el CSS lo revela con .ans-listo). Se marca el flag ANTES
     * de abrir para que `imponerInvariantesCajon` (disparado por el evento toggle) no lo re-cierre. */
    var opener = e.target.closest('[data-ans-open-drawer]');
    if (opener) {
      e.preventDefault();
      cajonTocadoPorLaClienta = true;
      var cajonOpen = $('#ans-drawer');
      if (cajonOpen && !cajonOpen.open) cajonOpen.open = true;
      return;
    }
    if (e.target.closest('.ans-drawer__trigger') || e.target.closest('[data-ans-drawer-close]')) {
      cajonTocadoPorLaClienta = true;
    }
  }, true);

  // --- Órdenes propios (enganche para §5) -----------------------------------

  function inyectarOrdenesPropios() {
    if (!ANS_ORDENES_PROPIOS.length) return; // hoy siempre sale por aquí
    var select = $('[data-ans-sort]');
    if (!select) return;
    ANS_ORDENES_PROPIOS.forEach(function (o) {
      if (select.querySelector('option[value="' + o.valor + '"]')) return;
      var opt = document.createElement('option');
      opt.value = o.valor;
      opt.textContent = o.etiqueta;
      select.appendChild(opt);
    });
  }

  /* SINCRONIZAR EL CONTROL CON LA URL — bug cazado por Enrique (12 ago 2026).
   *
   * Con `?sort_by=sale-descending` el grid SÍ se ordenaba por descuento (lo enruta
   * `esOrdenPropio` al worker), pero el desplegable mostraba "Más vendidos": Liquid
   * decide el `selected` con `collection.sort_by`, y Shopify no conoce nuestros órdenes
   * propios, así que reporta el default. Agregar la opción después no cambia la que ya
   * estaba seleccionada. Resultado: la etiqueta MENTÍA sobre lo que la clienta veía —
   * y al tocar cualquier filtro se reenviaba "best-selling", perdiendo su orden.
   *
   * El arreglo no es "poner sale-descending a mano": es que el control tome su valor de
   * la MISMA fuente de verdad que decide el render (la URL). Así queda cubierto
   * cualquier orden propio que se agregue después, sin tocar esta función.
   * No inventa: si la opción no existe en el select, no hace nada. */
  var ordenDelServidor = null;   // lo que el desplegable decía ANTES de que lo sincronizáramos con la URL

  /* Devuelve el desplegable a lo que el servidor pintó. Se llama cuando el orden propio NO se
   * pudo aplicar: sin esto la etiqueta anuncia un orden que la clienta no está viendo. */
  function restaurarOrdenDelServidor() {
    var select = $('[data-ans-sort]');
    if (!select || ordenDelServidor === null || select.value === ordenDelServidor) return;
    select.value = ordenDelServidor;
  }

  function sincronizarOrdenConUrl() {
    var select = $('[data-ans-sort]');
    if (!select) return;
    if (ordenDelServidor === null) ordenDelServidor = select.value;   // se guarda ANTES de tocarlo
    var deseado = new URLSearchParams(window.location.search).get('sort_by');
    if (!deseado || select.value === deseado) return;
    if (!select.querySelector('option[value="' + deseado.replace(/"/g, '') + '"]')) return;
    select.value = deseado;
  }

  // --- Slider de precio de dos manijas (Precio) -----------------------------

  /* MEJORA PROGRESIVA: los dos <input type=number> ya filtran sin JS (submit
   * nativo del form). Este slider es REALCE: se inyecta sobre esos mismos campos,
   * los mantiene sincronizados y reutiliza el pipeline `aplicar` (mismo debounce
   * que teclear en el campo). Sin librería (noUiSlider/jQuery UI): una dependencia
   * menos = un modo de fallo menos; el aspecto (track/relleno/manijas, medido de
   * Globo) lo da el CSS.
   *
   * Se llama en el arranque Y tras cada render (el panel se reemplaza entero, así
   * que el slider hay que reconstruirlo). Idempotente: marca la caja con
   * `data-ans-listo` y no la vuelve a construir. */
  function construirSliders() {
    $$('[data-ans-price]').forEach(function (cont) {
      var caja = $('[data-ans-price-slider]', cont);
      if (!caja || caja.getAttribute('data-ans-listo') === '1') return;

      var min = parseFloat(cont.getAttribute('data-ans-price-min'));
      var max = parseFloat(cont.getAttribute('data-ans-price-max'));
      /* Rango inválido (sin datos, o min>=max): se deja SOLO los campos. El
       * slider es un realce; nunca debe dejar la UI en un estado imposible. */
      if (!isFinite(min) || !isFinite(max) || max <= min) return;

      var prefijo = cont.getAttribute('data-ans-price-prefix') || '';
      var inMin = $('[data-ans-price-input="min"]', cont);
      var inMax = $('[data-ans-price-input="max"]', cont);
      var lblMin = $('.ans-price__label--min', cont);
      var lblMax = $('.ans-price__label--max', cont);
      if (!inMin || !inMax) return;

      caja.innerHTML =
        '<div class="ans-price__track">' +
          '<div class="ans-price__connect"></div>' +
          '<div class="ans-price__handle ans-price__handle--min" role="slider" tabindex="0" aria-label="Precio mínimo"></div>' +
          '<div class="ans-price__handle ans-price__handle--max" role="slider" tabindex="0" aria-label="Precio máximo"></div>' +
        '</div>';
      caja.setAttribute('data-ans-listo', '1');
      var track = $('.ans-price__track', caja);
      var connect = $('.ans-price__connect', caja);
      var hMin = $('.ans-price__handle--min', caja);
      var hMax = $('.ans-price__handle--max', caja);

      function fmt(v) {
        var s = Math.round(v).toFixed(2);           // "159.00"
        var p = s.split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); // separador de miles
        return prefijo + p.join('.');
      }
      function pct(v) { return ((v - min) / (max - min)) * 100; }
      function valDe(input, bound) {
        var v = parseFloat(input.value);
        if (!isFinite(v)) return bound;             // vacío/placeholder = el borde
        return Math.min(max, Math.max(min, v));
      }

      var estado = { min: valDe(inMin, min), max: valDe(inMax, max) };

      function pintar() {
        var pMin = pct(estado.min), pMax = pct(estado.max);
        hMin.style.left = pMin + '%';
        hMax.style.left = pMax + '%';
        connect.style.left = pMin + '%';
        connect.style.width = (pMax - pMin) + '%';
        hMin.setAttribute('aria-valuemin', min);
        hMin.setAttribute('aria-valuemax', Math.round(estado.max));
        hMin.setAttribute('aria-valuenow', Math.round(estado.min));
        hMin.setAttribute('aria-valuetext', fmt(estado.min));
        hMax.setAttribute('aria-valuemin', Math.round(estado.min));
        hMax.setAttribute('aria-valuemax', max);
        hMax.setAttribute('aria-valuenow', Math.round(estado.max));
        hMax.setAttribute('aria-valuetext', fmt(estado.max));
        if (lblMin) lblMin.textContent = fmt(estado.min);
        if (lblMax) lblMax.textContent = fmt(estado.max);
      }

      /* Vuelca el estado a los campos SIN aplicar. En un extremo (== borde) el
       * campo va VACÍO: así el envío NO manda `gte=0`/`lte=max` y el querystring
       * no se ensucia con un "filtro" que no filtra nada (mismo invariante que
       * los campos vacíos = sin límite, §2.2). */
      function volcarCampos() {
        inMin.value = (Math.round(estado.min) <= min) ? '' : String(Math.round(estado.min));
        inMax.value = (Math.round(estado.max) >= max) ? '' : String(Math.round(estado.max));
      }
      /* Aplica reusando el MISMO debounce que teclear en el campo (no un camino
       * paralelo): volcar → programar el aplicar del form. */
      function aplicarDesdeSlider() {
        volcarCampos();
        var form = obtenerForm();
        if (!form) return;
        clearTimeout(temporizadorPrecio);
        temporizadorPrecio = setTimeout(function () { aplicar(parametrosDesdeForm(form)); }, DEBOUNCE_PRECIO_MS);
      }

      function valDesdeX(clientX) {
        var r = track.getBoundingClientRect();
        if (!r.width) return estado.min;            // grupo colapsado: no mover
        var t = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
        return min + t * (max - min);
      }

      function arrastre(handle, cual) {
        handle.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          handle.setPointerCapture(e.pointerId);
          function mover(ev) {
            var v = valDesdeX(ev.clientX);
            if (cual === 'min') estado.min = Math.min(v, estado.max);
            else estado.max = Math.max(v, estado.min);
            pintar();
          }
          function soltar() {
            handle.removeEventListener('pointermove', mover);
            handle.removeEventListener('pointerup', soltar);
            handle.removeEventListener('pointercancel', soltar);
            aplicarDesdeSlider();
          }
          handle.addEventListener('pointermove', mover);
          handle.addEventListener('pointerup', soltar);
          handle.addEventListener('pointercancel', soltar);
        });

        handle.addEventListener('keydown', function (e) {
          var paso = (e.key === 'PageUp' || e.key === 'PageDown') ? Math.max(1, Math.round((max - min) / 10)) : 1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'PageUp') {
            if (cual === 'min') estado.min = Math.min(estado.min + paso, estado.max);
            else estado.max = Math.min(estado.max + paso, max);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'PageDown') {
            if (cual === 'min') estado.min = Math.max(estado.min - paso, min);
            else estado.max = Math.max(estado.max - paso, estado.min);
          } else if (e.key === 'Home') {
            estado[cual] = (cual === 'min') ? min : estado.min;
          } else if (e.key === 'End') {
            estado[cual] = (cual === 'max') ? max : estado.max;
          } else { return; }
          e.preventDefault();
          pintar();
          aplicarDesdeSlider();
        });
      }
      arrastre(hMin, 'min');
      arrastre(hMax, 'max');

      /* Campo → slider: teclear en el número mueve la manija (el aplicar lo hace
       * el listener delegado de precio con su debounce; aquí solo se repinta). */
      function desdeCampo() {
        estado.min = valDe(inMin, min);
        estado.max = valDe(inMax, max);
        if (estado.min > estado.max) { var t = estado.min; estado.min = estado.max; estado.max = t; }
        pintar();
      }
      inMin.addEventListener('input', desdeCampo);
      inMax.addEventListener('input', desdeCampo);

      pintar();
    });
  }

  // --- Arranque -------------------------------------------------------------

  // ── /search WORKER-DRIVEN (unificación con el desplegable, jul 28) ─────────────────────────────────────────
  /* EL BUG QUE ESTO MATA: el desplegable (worker /buscar) y la página /search daban resultados DISTINTOS —la
   * página usaba la búsqueda NATIVA de Shopify (ruidosa: "lima"→837), mientras el desplegable usaba el worker
   * (preciso: 23). badges.js sólo podía OCULTAR basura nativa, no AGREGAR ni REORDENAR lo que el worker sí
   * encuentra. Aquí /search pasa a rendirse ENTERA desde el MISMO motor del desplegable, vía el compositor
   * /busqueda (buscar→filtrar→ordenar→paginar + conteos de faceta). Así coinciden por construcción.
   *
   * Reusa lo YA probado: las cards son las REALES del tema (Section Rendering per-handle, cero drift); el panel de
   * Search & Discovery aporta la ESTRUCTURA de controles (sus name/value son EXACTAMENTE los params que
   * selDesdeParams del worker espera → el FormData mapea directo a /busqueda, sin traducción); los conteos por
   * valor se reescriben desde `facetas`. La nativa server-side sigue intacta (analítica/SEO/no-JS). RED dura:
   * cualquier fallo → render() nativo, NUNCA grid roto. */
  /* Página del worker: 12 para PAINT RÁPIDO. Cada card = un fetch (Section Rendering per-handle); menos cards en la
   * 1ª página = revela antes (el grid está oculto hasta que revela → menos "demora" percibida, hallazgo Enrique).
   * El resto entra al hacer scroll (infinite scroll). 12 = ~6 filas en móvil (2 col) / ~2.4 en escritorio (5 col). */
  var BW_SIZE = 12;
  var bwParams = null, bwPage = 1, bwTotal = 0, bwShown = 0, bwCargando = false;
  var bwPreloadUsable = true;   // el preload de search.liquid se consume UNA vez (carga inicial); después, fetch normal
  /* Cache PERSISTENTE handle→cardHTML del /search worker-driven. Se siembra COSECHANDO las cards que la nativa ya
   * pintó en el DOM (0 requests) y crece con cada card traída. Clave del rendimiento: la mayoría de los handles
   * del worker ya están en el DOM nativo (search nativa pagina de a 100) → casi no se pide nada. */
  var bwCache = Object.create(null);

  /* Guarda al cache las cards ya presentes en #ans-grid. La card nativa === ans-search-card (mismo
   * product-grid-item) → intercambiables sin drift. */
  function cosecharCards() {
    $$('#ans-grid .tt-col-item').forEach(function (it) {
      var h = handleDeCard(it);
      if (h && !bwCache[h]) bwCache[h] = it.outerHTML;
    });
  }

  /* La Section Rendering API (/products/<h>?sections=ans-search-card) envuelve la card en
   * <div id="shopify-section-ans-search-card" class="shopify-section">. Esa caja NO lleva clase de columna: si se
   * inserta tal cual en el grid FLEX, se vuelve el hijo flex y se dimensiona al CONTENIDO (ancho disparejo → grid
   * ROTO — bug cazado por Enrique jul 28, la card fetched daba 104px vs 180px de la nativa). Se EXTRAE la
   * .tt-col-item para que sea hija DIRECTA del grid, igual que las cosechadas del DOM nativo. */
  function desenvolverCard(html) {
    if (!html) return '';
    if (html.indexOf('shopify-section') === -1) return html;   // ya viene desnuda (cosechada de la nativa)
    var d = document.createElement('div'); d.innerHTML = html;
    var card = d.querySelector('.tt-col-item');
    return card ? card.outerHTML : html;
  }

  /* Trae al `cache` SÓLO los handles que faltan, con TOPE DE CONCURRENCIA (throttle). Pedir 24 secciones de
   * golpe topa el rate-limit de Shopify (403 → cards vacías, grid roto bajo carga). De a 8 no. Resuelve cuando
   * terminó de intentar todos (los que fallen quedan sin entrada; se descartan al ensamblar). */
  function asegurarCards(handles, cache) {
    var faltan = [];
    (handles || []).forEach(function (h) { if (h && !cache[h] && faltan.indexOf(h) < 0) faltan.push(h); });
    var CONC = 6, i = 0;   // ráfaga suave: 6 secciones a la vez esquiva el rate-limit de Shopify sin frenar el paint
    function siguiente() {
      if (i >= faltan.length) return Promise.resolve();
      var h = faltan[i++];
      return fetch('/products/' + encodeURIComponent(h) + '?sections=' + ANS_SEC_CARD)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j[ANS_SEC_CARD]) cache[h] = desenvolverCard(j[ANS_SEC_CARD]); })
        .catch(function () { /* handle sin card: se omite al ensamblar */ })
        .then(siguiente);
    }
    var arranques = [];
    for (var k = 0; k < Math.min(CONC, faltan.length); k++) arranques.push(siguiente());
    return Promise.all(arranques);
  }

  /* Ensambla el HTML de las cards de `handles` EN ORDEN, trayendo sólo lo que falte en `cache`. */
  function cardsEnOrden(handles, cache) {
    return asegurarCards(handles, cache).then(function () {
      return (handles || []).map(function (h) { return cache[h]; }).filter(Boolean);
    });
  }

  /* Fallback (nativa vacía): NO hay cards que cosechar → cache efímero, sólo aprovecha el throttle. */
  function fetchCardsPorHandles(handles) {
    return cardsEnOrden(handles, Object.create(null));
  }

  /* Cards del /busqueda (modo B): si el worker las devolvió YA renderizadas (data.cards, 1 request, rápido en
   * móvil), úsalas directo. Si no vienen (worker viejo, o falla), cae al per-handle (lento pero robusto = RED). */
  function cardsDeRespuesta(data) {
    if (data && Object.prototype.toString.call(data.cards) === '[object Array]' && data.cards.length) {
      return Promise.resolve(data.cards);
    }
    return cardsEnOrden((data && data.handles) || [], bwCache);
  }

  /* URL del compositor /busqueda desde los params del form (q + filter.* + sort_by). Se quitan los que no le
   * competen (page/sections/options[prefix]) y se fija page/size. `q` sale del form (hidden) o de la URL. */
  function urlBusqueda(params, page) {
    var qs = new URLSearchParams(params);
    qs.delete('page'); qs.delete('sections'); qs.delete('options[prefix]');
    if (!qs.get('q')) { var q = new URLSearchParams(location.search).get('q'); if (q) qs.set('q', q); }
    qs.set('page', String(page));
    qs.set('size', String(BW_SIZE));
    qs.set('cards', '1');   // modo B: el worker devuelve las cards YA renderizadas (1 request, sin fetches per-handle)
    return workerBase() + '/busqueda?' + qs.toString();
  }

  /* De un name de input del panel a su grupo de faceta (mismas claves que facetear()/selDesdeParams del worker). */
  function grupoDeInput(name) {
    var m = /ans_filtros\.(color|acabado|ocasion)\b/.exec(name || '');
    if (m) return m[1];
    if (name === 'filter.p.vendor') return 'vendor';
    return null;   // precio/disponibilidad/otros: no se tocan
  }

  /* Reescribe los conteos "(N)" del panel con los del estado del worker y OCULTA+DESHABILITA los valores en 0 no
   * seleccionados (igual que la nativa los quita del DOM). Se usa display inline (no [hidden]) para ganarle a
   * cualquier `display` del CSS del tema, y se puede revertir: quitar un filtro re-muestra los que vuelven a >0.
   * Un valor que el worker tiene pero que la nativa NO puso en el DOM inicial no puede aparecer (limitación
   * declarada: el conjunto de VALORES lo fija el panel nativo; la nativa suele ser superset). */
  function actualizarPanelDesdeFacetas(facetas) {
    facetas = facetas || {};
    $$('#ans-facets .ans-list__item').forEach(function (li) {
      var input = li.querySelector('input[type="checkbox"]');
      if (!input) return;
      var grupo = grupoDeInput(input.name);
      if (!grupo) return;
      var n = (facetas[grupo] || {})[input.value];
      var count = (typeof n === 'number') ? n : 0;   // facetear() omite los 0 → undefined ⇒ 0
      var cSpan = li.querySelector('.ans-box__count, .ans-check__count');
      if (cSpan) cSpan.textContent = '(' + count + ')';
      var texto = (li.querySelector('.ans-box__text, .ans-check__text') || {}).textContent || '';
      var vh = li.querySelector('.ans-visually-hidden');
      if (vh && texto) vh.textContent = texto + ' (' + count + ')';
      var ocultar = (count === 0 && !input.checked);
      li.style.display = ocultar ? 'none' : '';
      input.disabled = ocultar;   // deshabilitado = no viaja en el FormData ni se puede clicar un filtro muerto
    });
  }

  function pintarPaginacionBusqueda() {
    var pag = $(SEL_PAGINACION) || $(SEL_PAGINACION_RESPALDO);
    if (!pag) return;
    if (bwShown >= bwTotal) { pag.innerHTML = ''; pag.classList.add('hide'); return; }
    pag.classList.remove('hide');
    pag.innerHTML = '<div class="show-more"><a href="#" class="btn btn-border ttshowmorestyle" data-ans-mas-busqueda>' + (window.ANS_TXT_MAS || 'Mostrar más') + '</a></div>';
  }

  function cargarMasBusqueda() {
    if (bwCargando || bwShown >= bwTotal || !bwParams) return;
    bwCargando = true; spinnerMas(true);
    bwPage += 1;
    fetch(urlBusqueda(bwParams, bwPage))
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) { return cardsDeRespuesta(data); })
      .then(function (cards) {
        var grid = $('#ans-grid');
        if (grid && cards.length) grid.insertAdjacentHTML('beforeend', cards.join(''));
        bwShown += cards.length;
        if (!cards.length) bwShown = bwTotal;   // página vacía (fin real) → corta el "Mostrar más"
        spinnerMas(false); bwCargando = false;
        pintarPaginacionBusqueda();
        reengancharObservador();
      })
      .catch(function (err) {
        bwCargando = false; spinnerMas(false); bwPage -= 1;
        console.warn('[ans-facets] cargar más (búsqueda) falló:', (err && err.message) || err);
      });
  }

  /* ANTI-FLASH: revela el grid/conteo de /search (el CSS de search.liquid los oculta con `ans-bus-cargando` hasta
   * aquí, para no enseñar el "flashazo" de los resultados NATIVOS antes del swap al worker). Idempotente; se llama
   * en TODO camino de /search (worker ok, RED nativo, early-return, failsafe) → nunca deja el grid oculto. */
  function revelarBusqueda() {
    var g = $('#ans-grid'); if (g) g.classList.add('ans-bus-listo');
    $$('.ans-count-value').forEach(function (n) { n.classList.add('ans-bus-listo'); });
  }

  function renderBusquedaWorker(params) {
    var base = workerBase();
    var q = (params.get('q') || new URLSearchParams(location.search).get('q') || '').trim();
    var urlDestino = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    if (!base || !q) { revelarBusqueda(); return render(urlDestino); }   // sin worker/q → nativo (RED)
    /* Si search.liquid YA pintó las cards inline (preload, apenas llegaron ~carga del HTML), NO se re-renderiza el
     * grid: sólo se ADOPTA el estado (conteo/panel/paginación/interactividad). Así el grid es visible desde el
     * parse del HTML, no desde este JS diferido (que en tema pesado + 4G corre a ~10s). */
    if (bwPreloadUsable && window.__ansBusquedaPintadoInicial && window.__ansPreData) {
      bwPreloadUsable = false;
      var d = window.__ansPreData;
      bwParams = new URLSearchParams(params); bwParams.delete('page');
      bwTotal = d.total || 0; bwPage = 1;
      bwShown = (d.cards && d.cards.length) || 0;
      if (!bwShown && bwTotal) bwShown = bwTotal;
      actualizarPanelDesdeFacetas(d.facetas);
      pintarPaginacionBusqueda();
      anunciar(bwTotal); sincronizarChips(); sincronizarVacio(bwTotal);
      reengancharObservador();
      marcarCargando(false);
      revelarBusqueda();
      window.__ansBwRenders = (window.__ansBwRenders || 0) + 1;
      return Promise.resolve();
    }
    if (peticionEnCurso) { peticionEnCurso.abort(); peticionEnCurso = null; }
    marcarCargando(true);
    cosecharCards();   // captura las cards ya pintadas (nativas al cargar, del worker en re-renders) → 0 requests para ésas
    bwParams = new URLSearchParams(params); bwParams.delete('page');
    /* PRELOAD: en la 1ª llamada (carga inicial) usa la promesa que search.liquid disparó en paralelo con la página
     * (las cards ya vienen en camino). Si el preload falla o no aplica, fetch normal. Después, siempre fetch. */
    var pre = bwPreloadUsable ? (window.__ansBusquedaPreload && window.__ansBusquedaPreload.p) : null;
    bwPreloadUsable = false;
    var origen = pre
      ? pre.then(function (d) { return (d && Array.isArray(d.handles)) ? d : fetch(urlBusqueda(params, 1)).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }); })
      : fetch(urlBusqueda(params, 1)).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    return origen
      .then(function (data) {
        if (!data || !Array.isArray(data.handles)) throw new Error('respuesta sin handles');
        bwTotal = data.total || 0; bwPage = 1;
        return cardsDeRespuesta(data).then(function (cards) {
          var grid = $('#ans-grid'); if (!grid) throw new Error('sin #ans-grid');
          grid.innerHTML = cards.join('');
          grid.setAttribute('data-ans-count', String(bwTotal));
          bwShown = cards.length;
          if (!cards.length && bwTotal) bwShown = bwTotal;   // no se pudo pintar nada → no ofrecer "más"
          $$('.ans-count-value').forEach(function (n) { n.textContent = String(bwTotal); });
          actualizarPanelDesdeFacetas(data.facetas);
          pintarPaginacionBusqueda();
          anunciar(bwTotal); sincronizarChips(); sincronizarVacio(bwTotal);
          reengancharObservador();
          marcarCargando(false);
          revelarBusqueda();   // worker render listo → revela (mata el flashazo del grid nativo)
          /* Señal de "render worker terminado" (para pruebas y a11y): contador monotónico que se incrementa en
           * CADA render exitoso (inicial + filtro + orden). El gate lo observa en vez de un sleep fijo — el grid
           * nativo inicial ya tiene cards al instante, así que "hay cards" no distingue nativo de worker. */
          window.__ansBwRenders = (window.__ansBwRenders || 0) + 1;
        });
      })
      .catch(function (err) {
        marcarCargando(false);
        revelarBusqueda();   // RED: revela el grid nativo (nunca oculto para siempre)
        console.warn('[ans-facets] /search worker-driven falló, render nativo:', (err && err.message) || err);
        return render(urlDestino);   // RED: nunca grid roto
      });
  }

  // ── Fallback de /search: búsqueda NATIVA vacía → resultados del WORKER ─────────────────────────────────────
  /* La búsqueda nativa de Shopify falla en prefijos/typos/sinónimos ("tri"→"Trigo" → /search VACÍO) que el worker
   * SÍ resuelve. Cuando la nativa da 0 y el worker encuentra, se renderizan las cards REALES del tema (Section
   * Rendering per-handle: /products/<h>?sections=ans-search-card → add-to-cart/reseñas/badge de descuento nativos,
   * cero drift). SOLO toca el estado VACÍO nativo → las queries CON resultados conservan filtros/orden/analítica/
   * SEO/no-JS intactos. Cierra el hallazgo original (el desplegable prometía y /search entregaba vacío). */
  var FB_PAG = 24;   // la sección de card se comparte en ANS_SEC_CARD (definida arriba)
  var fbHandles = [], fbHechos = 0, fbCargando = false;

  function fallbackBusquedaWorker() {
    if (!/\/search\b/.test(location.pathname)) return;      // solo en /search
    /* RED HEREDADA, ya no el camino normal (jul 29 2026). Nació cuando /search con nativa-vacía NO emitía nada:
     * este fallback construía a mano un grid mínimo — y por eso la clienta veía productos SIN panel, sin orden y
     * sin "Filtrar por" (bug que cazó Enrique). Ahora search.liquid emite SIEMPRE el andamiaje completo, así que
     * si hay #ans-grid el camino bueno (renderBusquedaWorker + pintado inline) es el dueño y esto NO debe tocar
     * nada: montaría un segundo grid pobre encima del bueno. Sólo queda como red para un tema sin el andamiaje. */
    if ($('#ans-grid')) return;
    if (!$('.tt-empty-search')) return;                     // la nativa SÍ tuvo resultados → NO tocar nada
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (q.length < 2) return;
    var base = workerBase(); if (!base) return;
    fetch(base + '/buscar?q=' + encodeURIComponent(q) + '&limit=60')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var res = j && j.results;
        if (!res || !res.length) return;                    // el worker tampoco → dejar el estado vacío nativo tal cual
        fbHandles = res.map(function (x) { return x.handle; }).filter(Boolean);
        montarGridFallback(q);
        cargarMasFallback();
      })
      .catch(function () {});
  }

  function montarGridFallback(q) {
    var vacio = $('.tt-empty-search'); if (!vacio) return;
    var cont = vacio.closest('.container-indent') || vacio.parentNode;
    var esc = document.createElement('div'); esc.textContent = q;   // escape seguro del término
    cont.innerHTML =
      '<div class="container container-collection"><div class="content-indent">' +
      '<div class="tt-filters-options"><span class="ans-count"><b class="ans-count-value">' + fbHandles.length + '</b> Productos</span></div>' +
      '<div id="ans-grid" class="tt-product-listing row"></div>' +
      '<div class="text-center" style="padding:22px 0"><a href="#" class="btn btn-border ttshowmorestyle ans-fb-mas" style="display:none">Mostrar más</a></div>' +
      '</div></div>';
    var mas = $('.ans-fb-mas');
    if (mas) mas.addEventListener('click', function (e) { e.preventDefault(); cargarMasFallback(); });
  }

  function cargarMasFallback() {
    if (fbCargando) return;
    var lote = fbHandles.slice(fbHechos, fbHechos + FB_PAG);
    if (!lote.length) return;
    fbCargando = true;
    var mas = $('.ans-fb-mas'); if (mas) mas.textContent = 'Cargando…';
    fetchCardsPorHandles(lote).then(function (cards) {
      var grid = $('#ans-grid'); if (grid) grid.insertAdjacentHTML('beforeend', cards.join(''));
      fbHechos += lote.length; fbCargando = false;
      var m2 = $('.ans-fb-mas');
      if (m2) { m2.textContent = 'Mostrar más'; m2.style.display = fbHechos < fbHandles.length ? '' : 'none'; }
    }).catch(function () { fbCargando = false; });
  }

  function iniciar() {
    fallbackBusquedaWorker();   // /search con nativa vacía → cards del worker (ANTES del guard: el estado vacío no tiene form)
    /* Guarda de arranque: si no hay form (Search & Discovery sin instalar y
     * sin siquiera el selector de orden), el módulo NO hace nada y no lanza
     * ningún error. Degradar limpiamente es parte del contrato. */
    if (!obtenerForm()) return;

    /* Se marca el <html> como listo. El CSS usa `.ans-listo` para esconder el
     * botón "Aplicar filtros": el <noscript> cubre "sin JS" y esta clase cubre
     * "con JS"; el hueco entre ambos —JS activo pero este archivo bloqueado—
     * queda cubierto porque entonces esta línea NUNCA corre y el botón sigue
     * visible. Es el doble cinturón de §3.2. */
    document.documentElement.classList.add('ans-listo');

    /* SELLAR LA ENTRADA INICIAL DEL HISTORIAL.
     * Sin esto: la clienta llega a /collections/gel (entrada con state=null),
     * aplica un filtro (pushState con state.ans) y pulsa ATRÁS → el popstate
     * llega con state=null, la guarda "estado ajeno" lo descarta y la rejilla
     * se queda mostrando el estado FILTRADO mientras la URL dice lo contrario.
     * Marcar la entrada inicial como nuestra con replaceState hace que ese
     * atrás sí se renderice. replaceState no crea entrada nueva ni altera la
     * URL, así que no toca el historial de nadie más. */
    history.replaceState(
      { ans: window.location.search.replace(/^\?/, '') },
      '',
      window.location.href
    );

    inyectarOrdenesPropios();
    sincronizarOrdenConUrl();   // el control refleja la URL, no lo que Liquid adivinó
    engancharEventos();

    /* Si el servidor NO pudo honrar la URL (orden propio), el primer render lo hace el
     * cliente: sin esto la clienta llega por un enlace con "Mayor descuento" y ve el
     * orden por defecto, con la etiqueta diciendo otra cosa. */
    if (!servidorPudoHonrar(window.location.search)) {
      ultimoRender = window.location.search;
      // Por el MISMO despachador que usa `aplicar`, no por la ruta nativa: es la única
      // forma de que este camino no se quede atrás cuando se agregue otro motor. No se
      // toca el historial — ya se hizo `replaceState` unas líneas arriba.
      despacharRender(new URLSearchParams(window.location.search), window.location.href);
    }
    construirSliders();

    /* /search worker-driven: al CARGAR, se reemplaza el grid nativo por el del worker (mismo motor que el
     * desplegable → coinciden). Sólo cuando la nativa SÍ trajo resultados (hay #ans-grid + form de filtros); el
     * caso nativa-vacía lo cubre fallbackBusquedaWorker() más arriba. Si el worker falla, renderBusquedaWorker cae
     * a nativo (RED) y ese render re-engancha el observador. En colección / cualquier otra vista: auto-scroll normal. */
    if (ANS_SEARCH_WORKER_GRID && esBusqueda() && $('#ans-grid') && obtenerForm()) {
      setTimeout(revelarBusqueda, 6000);   // failsafe anti-flash: si el render se cuelga, el grid NO queda oculto para siempre
      renderBusquedaWorker(parametrosDesdeForm(obtenerForm()));
    } else {
      reengancharObservador();   // colección + /search modo A (grid nativo instantáneo): arranca el auto-scroll normal
    }
    sincronizarChips();   // deep-link con filtros al cargar: pinta la fila de chips activos desde el estado inicial
  }

  /* ARRANCAR CUANDO EXISTAN LAS PIEZAS, NO CUANDO TERMINE DE ANALIZARSE TODA LA PÁGINA.
   *
   * Medido en 4G el 12-ago-2026: el panel de filtros existía a los 7.0 s y el grid a los 7.6 s, pero
   * `DOMContentLoaded` no llegaba hasta los 23.3 s — el tema tiene recursos que bloquean el analizador. Con
   * `defer`, este módulo se quedaba esperando DIECISÉIS SEGUNDOS por algo que no necesita, y mientras tanto la
   * red de los 4 s revelaba el grid con el orden del SERVIDOR: la clienta veía el orden equivocado ~10 s y
   * luego le cambiaba delante. Ese era el parpadeo que reportó Enrique, y su causa no era el peso ni el
   * worker: era esperar la señal equivocada.
   *
   * La etiqueta pasó a `async` (se ejecuta en cuanto baja) y aquí se espera a lo ÚNICO que hace falta: que el
   * formulario y el grid estén en el DOM. `DOMContentLoaded` queda de RED para los casos donde esas piezas no
   * van a existir nunca (/search con resultado vacío, plantillas sin panel) — ahí no hay nada que esperar y
   * `iniciar()` ya sabe degradar. Arranque idempotente: sea cual sea la señal que llegue primero, corre UNA vez. */
  var arrancado = false, observadorArranque = null;
  /* Las piezas para RENDERIZAR son dos: el formulario (de donde sale el estado) y el grid (lo que se pinta).
   * La paginación NO entra aquí a propósito: se emite después de las ~50 cards del servidor y en 4G aparecía
   * 7.2 s más tarde que el grid (medido: grid 7.6 s · paginación 14.9 s). Exigirla retrasaba TODO el render
   * ese tiempo, y mientras tanto la red de los 4 s revelaba el orden equivocado. El auto-scroll, que es lo
   * único que la necesita, se engancha solo en cuanto aparece (ver `reengancharObservador`). Cada cosa espera
   * a lo suyo: así ni el render paga por el auto-scroll ni el auto-scroll se queda sin enganchar. */
  function piezasListas() { return !!(obtenerForm() && document.getElementById('ans-grid')); }
  function arrancarUnaVez() {
    if (arrancado) return;
    arrancado = true;
    if (observadorArranque) { observadorArranque.disconnect(); observadorArranque = null; }
    iniciar();
  }
  if (document.readyState !== 'loading' || piezasListas()) {
    arrancarUnaVez();
  } else {
    document.addEventListener('DOMContentLoaded', arrancarUnaVez);   // RED: cubre el caso sin panel
    if (typeof MutationObserver === 'function') {
      observadorArranque = new MutationObserver(function () { if (piezasListas()) arrancarUnaVez(); });
      observadorArranque.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
})();
